<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>mGauge Run Report</strong>
        </div>
        <b-row>
          <b-col class="col-lg-12 col-xl-12 my-0" v-if="showScanAlert()">
            <b-alert variant="warning" show>You are not able to run any more scans. You have achieved the run scan limit! [{{CurrentmGaugeReports}} scans / {{mGauge_Max_Scans}} max]</b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col>

            <b-row class="">

              <div class="headerCategory mr-1 bordered" style="display:flex;flex:2; ">
                <div class="category_title m-0">
                  <b-form-input type="text" placeholder="New Template Category" v-model="NewCategory"
                                class="form-control" size="sm" />
                </div>
                <div class="" @click="AddCustomCategory()">
                  <button><i class="fa fa-plus ml-1 mr-1 pt-1 " size="sm"></i></button>
                </div>
              </div>
              <div class="headerCategory m-0 p-0" style="display:flex;flex:1;justify-content:left">
                <div class="m-0 ml-4 mr-0 pl-2">
                  <input type="checkbox" @change="selectAll" v-model="IsAllSelection" style="display:flex;align-self:flex-start;margin-right:10px;" class="" />
                </div>
                <div class="ml-0 mr-1">
                  Select All
                </div>
              </div>
              <div class="headerCategory " style="display:flex;flex:3;">
                <div class="category_title m-0">
                  <b-form-input type="text" v-model="searchValue" placeholder="ID,Template Name, Vehicle Set" class="form-control" size="sm" />
                  <b-form-select v-model="scanMode" :options="scanModeSelect" size="sm" style="width:70px;">
                  </b-form-select>

                  <button @click="searchReport()"><i class="fa fa-search ml-1 mr-1 pt-1"></i>  </button>
                </div>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:1;">
                <label style="margin-left:10px;margin-top:7px;">Filtered [<strong>{{filteredReports.length}}</strong>]</label>
                <b-tooltip target="RunSelected" triggers="hover">
                  Run all selected reports
                </b-tooltip>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:1;">
                <b-button id="RunSelected" class="ml-2 mr-1" variant="success" size="sm" @click="runAllSelectedReports()">Run Selected</b-button>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:3;justify-content:start;">
                <div class="ml-5 mr-1">
                  Move To
                </div>
                <div class="category_title m-0">
                  <b-form-select v-model="MoveCategory" :options="TransferCategories" size="sm" class="form-control"
                                 value-field="CategoryId"
                                 text-field="CategoryName">
                  </b-form-select>
                  <b-button variant="success" size="sm" @click="moveSelectionToCategory()"><i class="fa fa-exchange ml-2 mr-2 pt-1"></i></b-button>
                </div>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:1;align-items:end;">

                <div class="m-1">
                  <button class="btn btn-info" style="width:100px;" @click="openEditionForm(-1)">
                    <i class="fa fa-plus"></i> New
                  </button>
                </div>
              </div>
            </b-row>
            <b-row>

              <div class="categories mr-1 bordered">
                <div>
                  <drop class="customCategory" v-for="category in mGauge_Categories"
                        v-bind:class="{ 'category_selected':boolLoading==false && IsCategorySelected(category.CategoryId) }"
                        ref="category"
                        @drop="function(transferData, nativeEvent) { handleDropCustom(category, transferData, nativeEvent) }">
                    <div class="category_title" @click="SetActiveCategory(category)" style="align-content:center;align-items:center;">
                      <span v-show="CategoryEditionActive.CategoryId==category.CategoryId">
                        <b-form-input class="" type="text" v-model="CategoryEditionActive.CategoryName" @blur="confirmSaveCategory(category)" />
                      </span>
                      <i class="fa fa-star " v-show="category.CategoryId==FAVORITES"></i>
                      <span class="ml-1" v-show="CategoryEditionActive.CategoryId!=category.CategoryId">{{category.CategoryName}}</span><span class="ml-2"> ({{category.ReportCount}})</span>
                    </div>
                    <div class="category_action">
                      <a href="#" @click="setToEditCategory(category)" v-show="CategoryEditionActive.CategoryId!=category.CategoryId && !category.IsDefault "><i class="fa fa-edit ml-2"></i></a>
                      <a href="#" @click="saveEditionCategory(category)" v-show="CategoryEditionActive.CategoryId==category.CategoryId && !category.IsDefault"><i class="fa fa-window-close ml-2"></i></a>
                      <a href="#" @click="archiveCategory(category)" v-show="CategoryEditionActive.CategoryId!=category.CategoryId && category.CategoryName!='Archive'"><i class="fa fa-trash ml-3"></i></a>
                    </div>
                  </drop>
                </div>

              </div>
              <div cols="10" class="template_rows">
                <div class="report_row_slim_header pl-4 pr-5">
                  <div class="ml-1 mr-1"></div>
                  <div class="report_id">Report Id</div>
                  <div class="report_template_name"><span>Title</span></div>
                  <div class="report_category">Scan Mode</div>
                  <div class="report_template_name">Vehicle Set</div>
                  <div class="report_is_active ml-0">Schedule</div>
                  <div class="report_action">Actions</div>
                </div>
                <drop v-for="template in this.filteredReports"
                      @drop="function(transferData, nativeEvent) { handleDropCustomSort(template, transferData, nativeEvent) }">
                  <drag class="report_row" :transfer-data="template"
                        v-bind:class="{report_row_hover : template.IsSelected==true}">

                    <div class="ml-1 mr-1" style="display:flex;flex-flow:row">
                      <a :id="`icon_button_favorites_${template.TemplateID}`" href="#" class="ml-0"
                         v-if="SelectedCategory.CategoryId!=FAVORITES"
                         style="display:flex" @click="moveReportToFavorites(template)">
                        <i class="fa fa-star ml-1"></i>
                      </a>
                      <b-tooltip :target="`icon_button_favorites_${template.TemplateID}`" triggers="hover">
                        Move to Favorites
                      </b-tooltip>
                      <input type="checkbox" v-model="template.IsSelected" value="true" unchecked-value="false" style="display:flex;align-self:center;" class="ml-2" />
                    </div>
                    <div class="report_id">{{template.TemplateID}}</div>
                    <div class="report_template_name"><span>{{template.title}}</span></div>

                    <div class="report_category">
                      {{template.scanMode}}
                    </div>
                    <div class="report_template_name">{{template.VSetTitle}}</div>
                    <div class="report_is_active">
                      <b-button :id="`button_enable_off${template.Scheduler_Id}`" variant="outline-primary" @click="openToggleEditionForm(template.TemplateID)"
                                v-if="template.Schedule_Active==false" style="width:70px;">
                        <span>OFF</span>
                      </b-button>
                      <b-button :id="`button_enable_on${template.Scheduler_Id}`" variant="success" @click="openToggleEditionForm(template.TemplateID)"
                                v-if="template.Schedule_Active" style="width:70px;">
                        <span>ON</span>
                      </b-button>
                    </div>
                    <b-tooltip :target="`button_enable_off${template.Scheduler_Id}`" triggers="hover">
                      Enabled schedule
                    </b-tooltip>
                    <b-tooltip :target="`button_enable_on${template.Scheduler_Id}`" triggers="hover">
                      Disable schedule
                    </b-tooltip>

                    <b-tooltip :target="`active_run_${template.Scheduler_Id}`" triggers="hover">
                      Run Active
                    </b-tooltip>

                    <div class="report_action" style="display:flex;flex-flow:row">
                      <a :id="`icon_button_view_runs_${template.TemplateID}`" href="#" class="ml-3" style="display:flex" @click="openViewRunReportsForm(template.TemplateID)">
                        <i class="fa fa-file ml-2"></i>
                      </a>
                      <b-tooltip :target="`icon_button_view_runs_${template.TemplateID}`" triggers="hover">
                        View run reports
                      </b-tooltip>
                      <a :id="`icon_button_edit_${template.TemplateID}`" href="#" class="ml-3" style="display:flex" @click="openEditionForm(template.TemplateID)">
                        <i class="fa fa-edit ml-2"></i>
                      </a>
                      <b-tooltip :target="`icon_button_edit_${template.TemplateID}`" triggers="hover">
                        Edit Template
                      </b-tooltip>
                      <a :id="`icon_button_trash_${template.TemplateID}`" href="#" class="ml-3  mr-4" style="display:flex"
                         v-if="SelectedCategory.CategoryId != ARCHIVES"
                         @click="moveReportToArchive(template)"><i class="fa fa-trash ml-2 "></i></a>
                      <b-tooltip :target="`icon_button_trash_${template.TemplateID}`" triggers="hover">
                        Move to Archive
                      </b-tooltip>
                    </div>

                    </drag>
                  </drop>
                </div>
              </b-row>

          </b-col>
        </b-row>

      </b-card>

      <b-modal size="xl" ref="ViewRunReports" hide-footer no-close-on-backdrop title="View Run Reports" show="modalOpen" class="policy-modal">
        <div cols="10" class="reports">
          <div class="report_row_slim_header">
            <div class="report_id"><strong>History ID</strong></div>
            <div class="report_template_name"><span><strong>Title</strong></span></div>
            <div class="report_user"><strong>Createdby</strong></div>
            <div class="report_date"><strong>Created</strong> </div>
            <div class="report_xls"><strong>XLS</strong></div>
            <div class="report_html"><strong>HTML</strong></div>
            <div class="report_json"><strong>JSON</strong></div>
          </div>
          <div class="report_row_slim" v-for="report in filteredRunReports">
            <div class="report_id">{{report.history_id}}</div>
            <div class="report_template_name"><span>{{report.title}}</span></div>
            <div class="report_user">{{report.createdby}}</div>
            <div class="report_date">{{report.created | formatDate }}</div>
            <div class="report_xls"> <a v-if="report.excel" href="#" @click="DownloadReport(report.excel)">XLS</a></div>
            <div class="report_html"><a v-if="report.html" href="#" @click="DownloadReport(report.html)">HTML</a></div>
            <div class="report_json"><a v-if="report.json" href="#" @click="DownloadReport(report.json)">JSON</a></div>
          </div>
        </div>
        <div style="display:flex;flex-flow:row-reverse">
          <button class="btn btn-primary mt-1" @click="closeVueRunReports">
            <i class="fa fa-window-close"></i> <strong class="text-white">Close</strong>
          </button>
        </div>
      </b-modal>
      <b-modal id="modal-prevent-closing" no-close-on-backdrop
               ref="modal"
               title="Save Report As"
               @show="resetModal"
               @hidden="resetModal"
               @ok="handleOk">

        <form ref="form" class="validationForm" data-vv-scope="NewTitle" @submit.stop.prevent="handleSubmit">
          <label>Report Name</label><br />
          <b-form-input id="report-input"
                        v-model="new_title"
                        v-validate="{required: true}" :maxlength="250"
                        v-bind:class="{'is-invalid': validateErrors.has('NewTitle.Report Name') }" name="Report Name"
                        required></b-form-input>
          <em class="error invalid-feedback">{{ validateErrors.first('NewTitle.Report Name') }}</em>
        </form>
      </b-modal>
      <b-modal no-close-on-backdrop size="xl" ref="AddEditTemplate" hide-footer title="Add/Edit Template" show="modalOpen" class="policy-modal"
               @shown="onShownAddEditTemplate"
               @hidden="hideAddEditTemplate">
        <!--BEGIN ***********************-->
        <div>
          <b-row style="vertical-align: middle;padding-bottom:5px;">
            <b-col md="6">

              <form class="validationForm" data-vv-scope="Title" onsubmit="event.preventDefault(); return false;">
                <label>Report Name</label><br />
                <b-form-input id="inpReportName" type="text" v-model="activeReport.title" :maxlength="250" v-validate="{required: true}"
                              v-bind:class="{'is-invalid': validateErrors.has('Title.Report Name') }" name="Report Name"></b-form-input>
                <em class="error invalid-feedback">{{ validateErrors.first('Title.Report Name') }}</em>
              </form>

            </b-col>
            <b-col md="6" v-if="activeReport.id!==undefined && activeReport.id >= 0">
              <label>Report Id</label><br />
              <dx-number-box v-model="activeReport.id" :disabled="true" />
            </b-col>

          </b-row>

          <div class="row mt-4">
            <div class="col">
              <b-card title="Card Title" no-body>
                <b-tabs v-model="wizardStep" @activate-tab="wizardTabClick" card>
                  <b-tab title="1. Calculation Settings" active>
                    <button id="btnNextCalcSetts" class="btn btn-primary pull-right mr-2" @click="wizardNextStep(1, 'Step1')">
                      <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                    </button>
                    <form class="validationForm" data-vv-scope="Step1" onsubmit="event.preventDefault(); return false;">
                      <b-row style="vertical-align: middle;padding-bottom:5px;" class="pt-2">
                        <b-col lg="6">
                          <div class="form-group row">
                            <label>Vehicle Set</label>
                            <dx-select-box id="selVehicleSet" style="width: 100%;" :items="vehicleSets" value-expr="id" display-expr="title" :value.sync="activeReport.vehicleSet"
                                           v-validate="{required: true}"
                                           name="Vehicle Set"
                                           :isValid="HasError('Step1.Vehicle Set')"
                                           :validationError="GetError('Step1.Vehicle Set')">

                            </dx-select-box>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="pt-4">
                        <b-col lg="3">
                          <label>Zip Code</label>
                          <dx-text-box id="inpZipCode" :value.sync="activeReport.zipCode"
                                       v-validate="{required: true, digits: 5}"
                                       name="Zip Code"
                                       :isValid="HasError('Step1.Zip Code')"
                                       :validationError="GetError('Step1.Zip Code')"></dx-text-box>
                        </b-col>
                        <b-col lg="3">
                          <label>Credit Score</label>
                          <dx-number-box id="inpCreditScore" v-model="activeReport.creditScore"
                                       v-validate="{required: true, digits: 3}"
                                       name="Credit Score"
                                       :isValid="HasError('Step1.Credit Score')"
                                       :validationError="GetError('Step1.Credit Score')"></dx-number-box>
                        </b-col>
                        <b-col lg="3">
                          <label>
                            Customer Cash
                            <slot v-if="activeReport.cashType !== 0" class="input-group-text ml-1 p-0"> (% of MSRP)</slot>
                          </label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select id="selCustCashType" v-model="activeReport.cashType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-number-box id="inpCustomerCash" class="form-control" v-model="activeReport.cashDown"
                                           v-validate="{required: true, min_value: 0, max_value:999999}"
                                           name="Customer Cash"
                                           :min="0"
                                           :max="999999"
                                           :isValid="HasError('Step1.Customer Cash')"
                                           :validationError="GetError('Step1.Customer Cash')"></dx-number-box>
                          </div>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanMode !== 1">
                          <label>Annual Mileage</label>
                          <dx-select-box id="annualMileagedd" :items="annualMileageOptions" value-expr="value" display-expr="text" :value.sync="activeReport.annualMileage"
                                         v-validate="{required: true}"
                                         name="Annual Mileage"
                                         :wrapItemText="true"
                                         :accept-custom-value="true"
                                         @customItemCreating="customItemCreating($event)"
                                         :isValid="HasError('Step1.Annual Mileage')"
                                         :validationError="GetError('Step1.Annual Mileage')">
                          </dx-select-box>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2 pt-4">
                        <b-col lg="3">
                          <label>Scan Mode</label>
                          <dx-select-box id="scanModedd" :items="scanModeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanMode"
                                         v-validate="{required: true}"
                                         name="Scan Mode"
                                         :onValueChanged="ScanModeChange"
                                         :isValid="HasError('Step1.Scan Mode')"
                                         :validationError="GetError('Step1.Scan Mode')" />
                        </b-col>
                        <b-col lg="3">
                          <label>Scan Type</label>
                          <dx-select-box id="scanTypedd" :items="scanTypeOptions" value-expr="value" display-expr="text" :value.sync="activeReport.scanType"
                                         v-validate="{required: true}"
                                         name="Scan Type"
                                         :isValid="HasError('Step1.Scan Type')"
                                         :validationError="GetError('Step1.Scan Type')" />
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 0">
                          <label>Adjustment Type</label>
                          <b-form-radio-group id="radGroupAdjustType" v-model="activeReport.adjustmentType" style="padding-top:6px;" :options="[
                                          {text: 'MSRP',value: 0},
                                          {text: 'Invoice',value: 1},
                                          ]">
                          </b-form-radio-group>
                        </b-col>
                        <b-col lg="3" v-if="activeReport.scanType === 0">
                          <label>Adjustment Value</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-number-box id="inpAdjustValueSellPrice" class="form-control" v-model="activeReport.adjustmentValue"
                                         v-validate="{required: true, min_value: -999999, max_value:999999}"
                                         name="Adjustment Value"
                                         :isValid="HasError('Step1.Adjustment Value')"
                                         :validationError="GetError('Step1.Adjustment Value')"></dx-number-box>
                          </div>
                        </b-col>
                        <b-col lg="2" v-if="activeReport.scanType === 1">
                          <label>Desired Profit</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <b-form-select v-model="activeReport.adjustmentValueType" :options="[
                                           {text:'$', value:0},
                                           ]">
                              </b-form-select>
                            </div>
                            <dx-text-box id="inpDesiredProfit" class="form-control" v-model="activeReport.adjustmentValue"
                                         v-validate="{required: true, min_value: 0, max_value:999999}"
                                         name="Adjustment Value"
                                         :isValid="HasError('Step1.Adjustment Value')"
                                         :validationError="GetError('Step1.Adjustment Value')"></dx-text-box>
                          </div>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step1')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="2. Lender Options">
                    <b-row>
                      <b-col md="12" class="mb-2 p-0">
                        <button id="btnBack" class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNext" class="btn btn-primary pull-right" @click="wizardNextStep(2, 'Step2')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step2" onsubmit="event.preventDefault(); return false;">
                      <b-row class="m-0">
                        <b-col lg="12" class="m-0 ">
                          <b-card class="m-0 mb-1 p-0">
                            <div class="m-0 pt-2" style="float:left;" v-if="!activeReport.applicableCaptiveLender"><strong>Tracked Lender</strong></div>
                            <div class="dx-fieldset my-0" style="float:left; width:50%;">
                              <div class="dx-field" v-if="!activeReport.applicableCaptiveLender">
                                <dx-lookup id="selTrackedLender" :items="availableLenders" style="z-index:99999"
                                           :value.sync="activeReport.trackedLender"
                                           :show-popup-title="true"
                                           display-expr="Name"
                                           placeholder="Select Tracked Lender"
                                           title="Select Tracked Lender"
                                           v-validate="{required: true}"
                                           name="Tracked Lender"
                                           :isValid="HasError('Step2.Tracked Lender')"
                                           :validationError="GetError('Step1.Tracked Lender')" />
                              </div>
                            </div>
                            <div class="m-0 pt-2" style="float:left;">
                              <span v-if="!activeReport.applicableCaptiveLender">or </span><span>Track Captive Lenders: </span>
                              <c-switch id="trackCaptLendSw" v-model="activeReport.applicableCaptiveLender" @change="clickApplicableCaptiveLender($event)" type="text" variant="primary" on="On"
                                        off="Off" :pill="true" />
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="7">
                          <b-card no-body>
                            <div slot="header" class="m-0">
                              <strong>Compared Lenders</strong>
                              <b-form-input id="inpCompLenderSearch" v-model="lenderSearch" class="ml-4 w-50" style="display:inline" placeholder="Type to Search" />
                            </div>
                            <b-row style="height: 324px; overflow: auto" class="m-0 p-0">
                              <b-col lg="12" class="m-0 p-0">
                                <table aria-busy="false" aria-colcount="2" class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr>
                                      <th aria-colindex="1" style="position: sticky; top: 0; z-index:200;">Lender Name</th>
                                      <th aria-colindex="2" style="position: sticky; top: 0; z-index:200;">
                                        <button @click="selectAllComparedLenders" class="btn btn-primary text-white btn-sm">
                                          <i title="Select/Unselect All Compared Lenders" class="fa fa-check-square"></i>
                                          {{ !activeReport.comparedLenders.length ? 'Select All' :'Unselect All' }}
                                        </button>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!availableLenders.length" class="b-table-empty-row">
                                      <td colspan="2">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No lenders found.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="(l, i) in filteredLenders">
                                      <td>
                                        {{l.Name}}
                                      </td>
                                      <td>
                                        <c-switch :id="l.Name" v-model="l.Compared" @change="updateComparedLenders" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                        <b-col lg="5">
                          <b-card no-body >
                            <div slot="header" style="height:35px;">
                              <div class="pt-2">
                                <strong>Selections</strong>
                              </div>                             
                            </div>

                            <b-row style="height: 324px; overflow: auto" class="m-0 p-0">
                              <b-col lg="12" class="m-0 p-0">
                                <table aria-busy="false" aria-colcount="2" class="table b-table table-striped table-bordered table-sm">
                                  <thead class="thead-light">
                                    <tr style="height:37px">
                                      <th aria-colindex="1">Lender Name</th>
                                      <th aria-colindex="2"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-if="!selectedComparedLenders.length" class="b-table-empty-row">
                                      <td colspan="3">
                                        <div role="alert" aria-live="polite">
                                          <div class="text-center my-2">No compared lenders selected.</div>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr v-for="(l, i) in selectedComparedLenders">
                                      <td>
                                        {{ l.Name }}
                                      </td>
                                      <td>
                                        <c-switch v-model="l.Compared" @change="updateComparedLenders" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step2')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="3. Rebate Options">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNextRebOptions" class="btn btn-primary pull-right" @click="wizardNextStep(3, 'Step3')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <b-alert v-if="VehicleSetIsNew" variant="info" dismissed="false" class="w-30" :show="true">
                      Note: These are conditional rebates.
                    </b-alert>
                    <b-alert v-else variant="info" dismissed="false" class="w-30" :show="true">
                      Note: There are no rebates for used vehicles.
                    </b-alert>
                    <form class="validationForm" data-vv-scope="Step3" onsubmit="event.preventDefault(); return false;">
                      <b-row v-bind:class="{'disableRebates': !VehicleSetIsNew}">
                        <b-col md="3">
                          <b-form-group>
                            <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                              <b-form-checkbox value="4">Loyalty</b-form-checkbox>
                              <b-form-checkbox value="5">Conquest</b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group>
                            <b-form-checkbox-group stacked v-model="activeReport.rebateOptions" :plain="false">
                              <b-form-checkbox value="2">College Graduate</b-form-checkbox>
                              <b-form-checkbox value="1">Military</b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step3')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="4. Target Acquisition Settings">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                        <button id="btnNextTargAcqSetts" class="btn btn-primary pull-right" @click="wizardNextStep(4, 'Step4')">
                          <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                        </button>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step4" onsubmit="event.preventDefault(); return false;">
                      <b-alert variant="info" dismissed="false" class="text-center" :show="true">
                        <b-row>
                          <b-col v-bind:class="{'col-md-9': activeReport.scanMode !== 1, 'col-md-4': activeReport.scanMode === 1, 'disableTA': !activeReport.useTargetAcquisition }" class="text-center">
                            <div class="my-2" style="float: left;">Target Payment:&nbsp;</div>
                            <div style="float:left; max-width:70px;">
                              <b-form-select v-model="activeReport.targetAcquisition.targetPaymentType" :options="[
                                           {text:'$', value:0},
                                           {text:'%', value:1},
                                           ]">
                              </b-form-select>
                            </div>
                            <div style="float:left; max-width:120px;">
                              <dx-number-box class="form-control" v-model="activeReport.targetAcquisition.targetPayment"
                                             v-validate="{required: activeReport.useTargetAcquisition}"
                                             name="Target Payment"
                                             :min="-99999"
                                             :max="99999"
                                             :isValid="HasError('Step4.Target Payment')"
                                             :validationError="GetError('Step4.Target Payment')" />
                            </div>
                          </b-col>
                          <slot v-if="activeReport.scanMode === 1">
                            <b-col md="3" v-bind:class="{'disableTA': !activeReport.useTargetAcquisition}">
                              <div class="my-2" style="float: left;">Min Interest Rate:&nbsp;</div>
                              <div style="float:left; max-width:70px;">
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.lowerInterestRate"
                                               id="lowerInterestRate"
                                               :onValueChanged="CalcRateChange"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Min Interest Rate" :min="0" :max="100"
                                               :isValid="HasError('Step4.Min Interest Rate')"
                                               :validationError="GetError('Step4.Min Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col md="3" v-bind:class="{'disableTA': !activeReport.useTargetAcquisition}">
                              <div class="my-2" style="float: left;">Max Interest Rate:&nbsp;</div>
                              <div style="float:left; max-width:70px;">
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseInterestRate"
                                               id="raiseInterestRate"
                                               :onValueChanged="CalcRateChange"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Interest Rate" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Interest Rate')"
                                               :validationError="GetError('Step4.Max Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                          </slot>
                          <b-col v-bind:class="{'disableTA': activeReport.useAverageReport, 'col-md-3': activeReport.scanMode !== 1, 'col-md-2': activeReport.scanMode === 1 }" class="my-2">
                            <div style="float:right;">
                              Enabled:
                              <c-switch id="swEnabled" v-model="activeReport.useTargetAcquisition" class="mb-0" type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                      </b-alert>
                      <div v-if="activeReport.scanMode === 0" v-bind:class="{'disableTA': !activeReport.useTargetAcquisition}">

                        <div class="ml-5 mt-4">
                          <i class="fa fa-arrow-down"></i> Lower Payment By:
                        </div>
                        <b-row>
                          <b-col xs="6" class="text-center">
                            <div>Lowering Rate: {{ activeReport.targetAcquisition.lowerRatePercentInRoll}}%</div>
                          </b-col>
                          <b-col xs="6" class="text-center">
                            <div>Increasing Residual Value: {{ 100 - activeReport.targetAcquisition.lowerRatePercentInRoll}}%</div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="12">
                            <div class="dx-field">
                              <DxSlider v-model="activeReport.targetAcquisition.lowerRatePercentInRoll" :min="0" :max="100" />
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 0">
                          </b-col>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 1">
                            <b-row>
                              <b-col xs="4">
                                <div>
                                  Min Money Factor:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.lowerMoneyFactor"
                                                 id="lowerMoneyFactor"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Min Money Factor"
                                                 :min="0"
                                                 :max="100"
                                                 :isValid="HasError('Step4.Min Money Factor')"
                                                 :validationError="GetError('Step4.Min Money Factor')"></dx-number-box>
                                </div>
                              </b-col>
                              <b-col xs="4" class="text-center">
                                <div>
                                  Min Interest Rate:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.lowerInterestRate"
                                                 id="lowerInterestRate"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Min Interest Rate" :min="0" :max="100"
                                                 :isValid="HasError('Step4.Min Interest Rate')"
                                                 :validationError="GetError('Step4.Min Interest Rate')"></dx-number-box>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <slot v-else>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 2">
                              <div>
                                Min Money Factor:
                                <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerMoneyFactor"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Min Money Factor" :min="0" :max="100"
                                               :isValid="HasError('Step4.Min Money Factor')"
                                               :validationError="GetError('Step4.Min Money Factor')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 3">
                              <div class="text-center">
                                Min Interest Rate:
                                <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerInterestRate"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Min Interest Rate" :min="0" :max="100"
                                               :isValid="HasError('Step4.Min Interest Rate')"
                                               :validationError="GetError('Step4.Min Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                          </slot>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 4">
                            <div class="text-center">
                              Min Interest Factor:
                              <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerInterestRate"
                                             v-validate="{required: activeReport.useTargetAcquisition}"
                                             name="Min Interest Factor" :min="0" :max="100"
                                             :isValid="HasError('Step4.Min Interest Factor')"
                                             :validationError="GetError('Step4.Min Interest Factor')"></dx-number-box>
                            </div>
                          </b-col>

                          <b-col xs="4" class="text-center">
                            <div>
                              Max RV% Adjustment : <br v-if="lenderCalcType === 1" />
                              <dx-number-box class="centerDiv" style="max-width: 100px;" v-model="activeReport.targetAcquisition.lowerResidualPctAdj"
                                             v-validate="{required: activeReport.useTargetAcquisition, min_value:0, max_value:99}"
                                             :min="1"
                                             :max="99"
                                             :step="1"
                                             format="##"
                                             name="Max RV percent"
                                             :isValid="HasError('Step4.Max RV percent')"
                                             :validationError="GetError('Step4.Max RV percent')"></dx-number-box>
                            </div>
                          </b-col>
                          <b-col xs="4" class="text-center">
                            <div>
                              Maintain Ratios at Limits : <br />
                              <c-switch v-model="activeReport.targetAcquisition.lowerMaintainRatiosAtLimits"
                                        type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                        <hr />
                        <div class="ml-5 mt-4">
                          <i class="fa fa-arrow-up"></i> Raise Payment By:
                        </div>
                        <b-row>
                          <b-col xs="6" class="text-center">
                            <div>Increasing Rate: {{ activeReport.targetAcquisition.raiseRatePercentInRoll}}%</div>
                          </b-col>
                          <b-col xs="6" class="text-center">
                            <div>Lowering Residual Value: {{ 100 - activeReport.targetAcquisition.raiseRatePercentInRoll}}%</div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col lg="12">
                            <div class="dx-field">
                              <DxSlider v-model="activeReport.targetAcquisition.raiseRatePercentInRoll" :min="0" :max="100" />
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 0">
                          </b-col>
                          <b-col xs="4" class="text-center" v-if="lenderCalcType === 1">
                            <b-row>
                              <b-col xs="4">
                                <div>
                                  Max Money Factor:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.raiseMoneyFactor"
                                                 id="raiseMoneyFactor"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Max Money Factor" :min="0" :max="99"
                                                 :isValid="HasError('Step4.Max Money Factor')"
                                                 :validationError="GetError('Step4.Max Money Factor')"></dx-number-box>
                                </div>
                              </b-col>
                              <b-col xs="4" class="text-center">
                                <div>
                                  Max Interest Rate:
                                  <dx-number-box class="centerDiv" style="max-width: 100px;"
                                                 v-model="activeReport.targetAcquisition.raiseInterestRate"
                                                 id="raiseInterestRate"
                                                 :onValueChanged="CalcRateChange"
                                                 v-validate="{required: activeReport.useTargetAcquisition}"
                                                 name="Max Interest Rate" :min="0" :max="99"
                                                 :isValid="HasError('Step4.Max Interest Rate')"
                                                 :validationError="GetError('Step4.Max Interest Rate')"></dx-number-box>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                          <slot v-else>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 2">
                              <div>
                                Max Money Factor:
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseMoneyFactor"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Money Factor" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Money Factor')"
                                               :validationError="GetError('Step4.Max Money Factor')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 3">
                              <div>
                                Max Interest Rate:
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseInterestRate"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Interest Rate" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Interest Rate')"
                                               :validationError="GetError('Step4.Max Interest Rate')"></dx-number-box>
                              </div>
                            </b-col>
                            <b-col xs="4" class="text-center" v-if="lenderCalcType === 4">
                              <div>
                                Max Interest Factor:
                                <dx-number-box class="centerDiv" style="max-width: 100px;"
                                               v-model="activeReport.targetAcquisition.raiseInterestRate"
                                               v-validate="{required: activeReport.useTargetAcquisition}"
                                               name="Max Interest Factor" :min="0" :max="99"
                                               :isValid="HasError('Step4.Max Interest Factor')"
                                               :validationError="GetError('Step4.Max Interest Factor')"></dx-number-box>
                              </div>
                            </b-col>
                          </slot>
                          <b-col xs="4" class="text-center">
                            <div>
                              Min RV% : <br v-if="lenderCalcType === 1" />
                              <dx-number-box class="centerDiv" style="max-width: 100px;"
                                             v-model="activeReport.targetAcquisition.raiseResidualPctAdj"
                                             v-validate="{required: activeReport.useTargetAcquisition, min_value:20, max_value:99}"
                                             :min="20"
                                             :max="99"
                                             :step="1"
                                             format="##"
                                             name="Min RV percent"
                                             :isValid="HasError('Step4.Min RV percent')"
                                             :validationError="GetError('Step4.Min RV percent')"></dx-number-box>
                            </div>
                          </b-col>
                          <b-col xs="4" class="text-center">
                            <div>
                              Maintain Ratios at Limits : <br />
                              <c-switch v-model="activeReport.targetAcquisition.raiseMaintainRatiosAtLimits"
                                        type="text" variant="primary" on="On" off="Off" :pill="true" />
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step4')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                  </b-tab>
                  <b-tab title="5. Report Settings">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <b-col md="12" class="mb-4 p-0">
                          <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                            <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                          </button>
                          <button id="btnNextReportSetts" class="btn btn-primary pull-right" @click="wizardNextStep(5, 'Step5')">
                            <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                          </button>
                        </b-col>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step5" onsubmit="event.preventDefault(); return false;">
                      <b-row v-if="activeReport.scanMode === 0" class="w-75">
                        <label>Lease Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallLeaseTerms(false)">Unselect All</a>
                        <b-form-group>
                          <b-form-checkbox-group v-model="activeReport.terms"
                                                 :checked="activeReport.terms"
                                                 :plain="false"
                                                 v-validate="{required: true}"
                                                 name="Terms"
                                                 :isValid="HasError('Step5.Terms')">
                            <b-form-checkbox v-for="t in leaseTerms" :value="t" v-bind:key="t" :id="t">
                              {{ t.toString() }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-row>
                      <b-row v-if="activeReport.scanMode === 1" class="w-75">
                        <label>Retail Terms:</label>&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(true)">Select All</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" @click="selectallRetailTerms(false)">Unselect All</a>
                        <b-form-group>
                          <b-form-checkbox-group v-model="activeReport.terms"
                                                 :checked="activeReport.terms"
                                                 :plain="false"
                                                 v-validate="{required: true}"
                                                 name="Terms"
                                                 :isValid="HasError('Step5.Terms')">
                            <b-form-checkbox v-for="t in retailTerms" :value="t" v-bind:key="t" :id="t">
                              {{ t.toString() }}
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-row>
                      <b-row><label>Options:</label></b-row>
                      <b-row>
                        <b-form-checkbox class="ml-4" v-model="activeReport.includeOnlyTermsWithTrackedLenderPresent">Only display terms that include Tracked Lender Programs</b-form-checkbox>
                      </b-row>
                      <b-row>
                        <b-form-checkbox id="chkUseAvgReport" class="ml-4" v-bind:class="{'disableTA': accessAverageReportOnly}" v-model="activeReport.useAverageReport" @change="ChangeUseAverageReport">Use Average Report</b-form-checkbox>
                      </b-row>
                      <b-row>
                        <b-col lg="3" class="p-0">
                          <label class="mt-2">Group Results By:</label>
                          <b-form-select id="groupByDropDown" v-model="activeReport.groupBy"
                                         v-on:change="setSelectedGroupBy(activeReport.groupBy)"
                                         :options="[
                                           {text:'None (Recommended)', value:0},
                                           {text:'Make and Model', value:1},
                                           {text:'Vehicle Class', value:2},
                                           {text:'Vehicle Category', value:4},
                                           {text:'Vehicle Class and Category', value:3}
                                           ]">
                          </b-form-select>
                        </b-col>
                        <b-col lg="3">
                          <label class="mt-2">Display {{ scanModeOptions[activeReport.scanMode].text }} Programs</label>
                          <b-form-select id="displayProgramOptionsd" :options="displayProgramOptions" v-model="activeReport.displayProgramOption"
                                         v-validate="{required: true}"
                                         name="Display Program Options" />
                        </b-col>
                        <b-col lg="3">

                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="3" class="p-0">
                          <b-row style="max-width:250px;">
                            <label class="mt-2">Template Category</label>
                            <b-form-select v-model="activeReport.CategoryId" :options="mGauge_Categories"
                                           value-field="CategoryId"
                                           text-field="CategoryName">
                            </b-form-select>
                          </b-row>
                          <b-row style="max-width:250px;">
                            <label class="mt-2">Report Category</label>
                            <b-form-select v-model="activeReport.DefaultHistoryCategoryId" :options="ReportHistoryCategories"
                                           value-field="CategoryId"
                                           text-field="CategoryName">
                            </b-form-select>
                          </b-row>
                        </b-col>
                      </b-row>
                      <!--<b-row>
                        <label class="mt-2">Sort By:</label>
                      </b-row>

                      <b-row style="max-width:250px;">
                        <b-form-select id="sortByDropDown" v-model="activeReport.sortBy" :options="[
                                           {text:'Spread $', value:0},
                                           {text:'Spread %', value:1},
                                           {text:'Payment Value Index (PVI)', value:3},
                                           {text:'Best Payment', value:5},
                                           {text:'MSRP', value:4},
                                           {text:'Vehicle (Year, Make, Model, Trim)', value:2},
                                           ]">
                        </b-form-select>
                      </b-row>-->                      
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step5')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                    <b-row hidden>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-right" @click="runReport">
                          <i class="fa fa-dot-circle-o"></i> <strong class="text-white">Run Report</strong>
                        </button>
                        <button class="btn btn-warning pull-right mr-2" @click="SchedulerOpenClick">
                          <i class="fa fa-calendar text-white"></i> <strong class="text-white">Schedule</strong>
                        </button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="6. Column Sorting">
                    <b-row>
                      <b-col md="12" class="mb-4 p-0">
                        <b-col md="12" class="mb-4 p-0">
                          <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                            <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                          </button>
                          <button id="btnNextReportSetts" class="btn btn-primary pull-right" @click="wizardNextStep(6, 'Step6')">
                            <strong class="text-white">Next <i class="fa fa-chevron-circle-right"></i></strong>
                          </button>
                        </b-col>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step5" onsubmit="event.preventDefault(); return false;">
                     
                      <b-row>
                        <label class="mt-2">Sort By:</label>
                      </b-row>

                      <b-row style="max-width:250px;">
                        <b-form-select id="sortByDropDown" v-model="activeReport.sortBy" :options="[
                                           {text:'Spread $', value:0},
                                           {text:'Spread %', value:1},
                                           {text:'Payment Value Index (PVI)', value:3},
                                           {text:'Best Payment', value:5},
                                           {text:'MSRP', value:4},
                                           {text:'Vehicle (Year, Make, Model, Trim)', value:2},
                                           ]">
                        </b-form-select>
                      </b-row>
                      <b-row md="12" style="max-width:800px;" class="mt-2">
                        Use default columns
                        <div style="float:right;" class="ml-2">
                          <b-form-checkbox id="chkUseReportDefaultColumns" v-model="UseReportDefaultColumns" @change="UseReportDefaultColumnsChange">Enabled</b-form-checkbox>
                          <!--<c-switch v-model="UseReportDefaultColumns" class="mb-0" type="text" variant="primary" on="On" off="Off" :pill="true" :checked="UseReportDefaultColumnsChange" />-->
                        </div>
                      </b-row>                    
                      <b-row>
                        <b-col md="4" class="p-1">
                          <b-row>
                            Available columns
                          </b-row>
                          <div style="border:1px solid gray;height:250px; overflow-y:auto;">
                            <div class="report-column">
                              <span>
                                <input type="checkbox" v-model="ReportAvailableColumnsCheckbox" @click="setReportColumnSelectedValue(ReportAvailableColumns,ReportAvailableColumnsCheckbox)"
                                       :disabled="UseReportDefaultColumns " /> 
                              </span>
                              <span class="ml-2">All</span>
                            </div>
                            <div class="" v-for="column in ReportAvailableColumns"
                                  >
                              <div class="report-column" :transfer-data="column" v-bind:class="{report_column_hover : column.isChecked==true}" >
                                
                                <span>
                                  <input type="checkbox"  v-model="column.isChecked"   :disabled="UseReportDefaultColumns"/>
                                </span>
                                <span class="ml-2"> {{column.columnName}} </span>
                              </div>                              
                            </div>
                          </div>
                        </b-col>
                          <b-col md="2" class="p-1 d-flex">
                            <div style="margin:auto;">
                              <button class="btn btn-info btn-lg align-self-center" @click="addSelectedToAvailable()" :disabled="UseReportDefaultColumns">
                                <i class="fa fa-arrow-left"></i>
                              </button>
                              <button href="#" class="btn btn-info btn-lg align-self-center ml-3" @click="addAvailableToSelected()" :disabled="UseReportDefaultColumns">
                                <i class="fa fa-arrow-right"></i>
                              </button>
                            </div>
                          </b-col>
                          <b-col md="4" class="p-1">
                            <b-row>
                              Select and Order Columns
                            </b-row>
                            <div style="border:1px solid gray;height:250px; overflow-y:auto;">
                              <div class="report-column">
                                <span>
                                  <input type="checkbox" v-model="ReportSelectedColumnsCheckbox" @click="setReportColumnSelectedValue(ReportSelectedColumns,ReportSelectedColumnsCheckbox)" :disabled="UseReportDefaultColumns"/>
                                </span>
                                <span class="ml-2">All</span>
                              </div>
                              <drop class="" v-for="column in ReportSelectedColumns"
                                    ref="column"
                                    @drop="function(transferDataColumn, nativeEvent) { handleDropCustomColumn(column, transferDataColumn, nativeEvent) }">
                                <drag class="report-column grab" :transfer-data="column" v-bind:class="{report_column_hover : column.isChecked==true}">
                                  <!--v-bind:class="{report_row_hover : column.isChecked==true}"-->
                                  <span>
                                    <input type="checkbox" v-model="column.isChecked"   :disabled="UseReportDefaultColumns"/>
                                  </span>
                                  <span class="ml-2"> {{column.columnName}} </span>
                                </drag>                                
                              </drop>
                            </div>
                          </b-col>
                        </b-row>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step6')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                    <b-row hidden>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-primary pull-right" @click="runReport">
                          <i class="fa fa-dot-circle-o"></i> <strong class="text-white">Run Report</strong>
                        </button>
                        <button class="btn btn-warning pull-right mr-2" @click="SchedulerOpenClick">
                          <i class="fa fa-calendar text-white"></i> <strong class="text-white">Schedule</strong>
                        </button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="7. Report Schedule">
                    <b-row>
                      <b-col md="6" class="mb-4 p-0">
                        <button class="btn btn-primary pull-left" @click="wizardBackStep()">
                          <strong class="text-white"><i class="fa fa-chevron-circle-left"></i> Back</strong>
                        </button>
                      </b-col>
                      <b-col md="6" class="my-2 py-2">
                        <div style="float:right;">
                          Enabled:
                          <c-switch v-model="scheduler.IS_ACTIVE" class="mb-0" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </div>
                      </b-col>
                    </b-row>
                    <form class="validationForm" data-vv-scope="Step6" onsubmit="event.preventDefault(); return false;">
                      <template>
                        <div class="popup-property-details">
                          <div class="row">
                            <div class="col-3">
                              <div class="buttons-column">
                                <div class="column-header">
                                  Day of the month:
                                </div>
                                <div>
                                  <dx-select-box :value.sync="scheduler.newDate" :items="scheduler.AvailableDates" />
                                </div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="buttons-column">
                                <div class="column-header">
                                  Local time:
                                </div>
                                <div>
                                  <dx-date-box :value.sync="scheduler.newTime" :display-format="scheduler.use24format? 'HH:mm' : 'shortTime' " type="time" />
                                </div>
                              </div>
                            </div>
                            <div class="col-3 vcenter">
                              <div class="buttons-column">
                                <div class="column-header">
                                  &nbsp;
                                </div>
                                <div>
                                  <dx-switch width="100" :value.sync="scheduler.use24format" switchedOnText="24 HR" switchedOffText="AM/PM" />
                                </div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="buttons-column">
                                <div class="column-header">
                                  &nbsp;
                                </div>
                                <div style="float: right">
                                  <dx-button text="Add Date" styling-mode="outlined" type="default" :onClick="SchedulerAddDateTimeClick"
                                             :disabled="!SchedulerCanAdd" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div class="row">
                            <dx-list :data-source="scheduler.SCHEDULE" noDataText="No dates scheduled" :height="250" width="100%"
                                     :onItemClick="SchedulerItemClick"
                                     itemDeleteMode="toggle" :allowItemDeleting="true">
                              <template #item="{ data }">
                                <div class="row" style="display: flex !important; padding: 2px">
                                  <div class="col-md-3 vcenter">
                                    <span>{{data.date}}{{ SchedulerNth(data.date) }} day of month</span>
                                  </div>
                                  <div class="col-md-8">
                                    <dx-tag-box :items.sync="data.times" :value.sync="data.times" :displayExpr="SchedulerItemFormat" stylingMode="underlined" :search-enabled="false"
                                                :onValueChanged="SchedulerOnTimeValueChanged" />
                                  </div>
                                </div>
                              </template>
                            </dx-list>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-6">
                              <div class="buttons-column">
                                <div class="column-header">
                                  Add new email recipient:
                                </div>
                                <div>
                                  <dx-text-box :value.sync="scheduler.newEmail" mode="email" valueChangeEvent="keyup"
                                               name="Email" />
                                </div>
                              </div>
                            </div>
                            <div class="offset-3 col-3">
                              <div class="buttons-column">
                                <div class="column-header">
                                  &nbsp;
                                </div>
                                <div style="float: right">
                                  <dx-button text="Add Email" styling-mode="outlined" type="default" :onClick="SchedulerAddEmail"
                                             :disabled="!SchedulerCanAddEmail" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-12">
                              <div class="buttons-column">
                                <div class="column-header">
                                  Emails:
                                </div>
                                <div>
                                  <dx-tag-box :items.sync="scheduler.SCHEDULE_EMAIL" :value.sync="scheduler.SCHEDULE_EMAIL" stylingMode="underlined"
                                              :max-displayed-tags="5"
                                              :show-multi-tag-only="false"
                                              placeholder="No recipients added"
                                              :search-enabled="false"
                                              v-validate="{required: scheduler.SCHEDULE.length > 0 && scheduler.IS_ACTIVE}"
                                              :isValid="HasError('Step6.SCHEDULE_EMAIL')"
                                              :validationError="GetError('Step6.SCHEDULE_EMAIL')"
                                              name="SCHEDULE_EMAIL" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </form>
                    <div class="my-2">
                      <span class="text-danger" v-for="item in validateErrors.items.filter(r=>r.scope === 'Step6')" v-bind:key="item.id">
                        {{ `#${item.id}: ${item.msg}`}}
                        <br />
                      </span>
                    </div>
                    <b-row hidden>
                      <b-col md="12" class="mb-4 p-0">
                        <button class="btn btn-warning pull-right mr-2" @click="SchedulerSaveClick">
                          <i class="fa fa-calendar text-white"></i> <strong class="text-white">Save Schedule</strong>
                        </button>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </div>
          <b-row class="mx-2">
            <b-col md="12">
              <button class="btn btn-primary" @click="saveReportTemplate" :disabled="changesSaved">
                <i class="fa fa-save"></i> <strong class="text-white">Save</strong>
              </button>
              <button class="btn btn-primary" v-b-modal.modal-prevent-closing>
                <i class="fa fa-save"></i> <strong class="text-white">Save As</strong>
              </button>
              <slot v-if="canRunReport && validateErrors.items.length === 0 && showRunReport()">
                <button id="btnRunReportRepSched" class="btn btn-primary pull-right" @click="runReport">
                  <i class="fa fa-dot-circle-o"></i> <strong class="text-white">Run Report</strong>
                </button>
                  <button class="btn btn-warning pull-right mr-2" @click="SchedulerOpenClick" hidden>
                    <i class="fa fa-calendar text-white"></i> <strong class="text-white">Schedule</strong>
                  </button>
                </slot>
            </b-col>
          </b-row>
        </div>

      </b-modal>
      <b-modal ref="modalTimezoneWarning" no-close-on-backdrop
               title="Warning"
               @show=""
               @hidden="modalTimeZoneWarningHandleHidden"
               @ok="modalTimeZoneWarningHandleOK">

        <b-row>
          <!--v-if="user.TIMEZONES.length>0"-->
          <b-col md="12" class="my-0">
              In order to schedule a report you must specify a time zone
          </b-col>
        </b-row>
        <b-row>
          <!--v-if="user.TIMEZONES.length>0"-->
          <b-col md="10" class="my-0">
            <b-row class="my-1">
              <b-col md="2"><label for="input-default"></label></b-col>
              <b-col md="7">
                <b-form-select v-model="user.TIMEZONE_ID" :options="user.TIMEZONES">
                </b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      </b-modal>
    </div>
    <dx-popup
      :width="700"
      :height="650"
      :show-title="true"
      :title="scheduler.title"
      :drag-enabled="false"
      :showCloseButton="false"
      :close-on-outside-click="false"
      :visible.sync="scheduler.schedulerVisible"
    >
      <template>
        <div class="popup-property-details">
          <div class="row" >
            <div class="col-3">
              <div class="buttons-column">
                <div class="column-header">
                  Day of the month:
                </div>
                <div>
                  <dx-select-box :value.sync="scheduler.newDate" :items="scheduler.AvailableDates"/>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="buttons-column">
                <div class="column-header">
                  Local time:
                </div>
                <div>
                  <dx-date-box :value.sync="scheduler.newTime" :display-format="scheduler.use24format? 'HH:mm' : 'shortTime' " type="time"/>
                </div>
              </div>
            </div>
            <div class="col-3 vcenter">
              <div class="buttons-column">
                <div class="column-header">
                  &nbsp;
                </div>
                <div>
                  <dx-switch width="100" :value.sync="scheduler.use24format" switchedOnText="24 HR" switchedOffText="AM/PM"/>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="buttons-column">
                <div class="column-header"> &nbsp;
                </div>
                <div style="float: right">
                  <dx-button text="Add Date" styling-mode="outlined" type="default" :onClick="SchedulerAddDateTimeClick"
                             :disabled="!SchedulerCanAdd"/>
                </div>
              </div>
            </div>
          </div>
          <br/>
          <div class="row">
            <dx-list :data-source="scheduler.SCHEDULE" noDataText="You didn't add any dates yet" :height="250" width="100%"
                     :onItemClick="SchedulerItemClick"
                     itemDeleteMode="toggle" :allowItemDeleting="true">
              <template #item="{ data }">
                <div class="row" style="display: flex !important; padding: 2px">
                  <div class="col-md-3 vcenter">
                    <span>{{data.date}}{{ SchedulerNth(data.date) }} day of month</span>
                  </div>
                  <div class="col-md-8">
                    <dx-tag-box :items.sync="data.times" :value.sync="data.times" :displayExpr="SchedulerItemFormat" stylingMode="underlined" :search-enabled="false"
                                :onValueChanged="SchedulerOnTimeValueChanged"/>
                  </div>
                </div>
              </template>
            </dx-list>
          </div>
          <br/>
          <div class="row">
            <div class="col-6">
              <div class="buttons-column">
                <div class="column-header">
                  Add new email recipient:
                </div>
                <div>
                  <dx-text-box :value.sync="scheduler.newEmail" mode="email" valueChangeEvent="keyup"/>
                </div>
              </div>
            </div>
            <div class="offset-3 col-3">
              <div class="buttons-column">
                <div class="column-header"> &nbsp;
                </div>
                <div style="float: right">
                  <dx-button text="Add Email" styling-mode="outlined" type="default" :onClick="SchedulerAddEmail"
                             :disabled="!SchedulerCanAddEmail"/>
                </div>
              </div>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12">
              <div class="buttons-column">
                <div class="column-header">
                  Emails:
                </div>
                <div>
                  <dx-tag-box :items.sync="scheduler.SCHEDULE_EMAIL" :value.sync="scheduler.SCHEDULE_EMAIL" stylingMode="underlined"
                              :max-displayed-tags="5"
                              :show-multi-tag-only="false"
                              placeholder="No emails has been added yet"
                              :search-enabled="false"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <dx-toolbar-item
        widget="dxButton"
        toolbar="bottom"
        :options="scheduler.ButtonSave"
        location="after">
      </dx-toolbar-item>
      <dx-toolbar-item
        widget="dxButton"
        toolbar="bottom"
        :options="scheduler.ButtonCancel"
        location="after">
      </dx-toolbar-item>
    </dx-popup>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import notify from 'devextreme/ui/notify'
import moment from 'moment'
import { Drag, Drop } from 'vue-drag-drop'

// eslint-disable-next-line no-unused-vars
import {Validator} from 'vee-validate'

import {
  DxTextBox,
  DxSlider,
  DxNumberBox,
  DxLookup,
  DxSelectBox,
  DxSwitch,
  DxDropDownBox,
  DxDateBox,
  DxButton,
  DxTagBox
  } from 'devextreme-vue'
  import { DxItemDragging, DxList } from 'devextreme-vue/list'
import DxPopup, {DxToolbarItem} from 'devextreme-vue/popup'
import { confirm, alert } from 'devextreme/ui/dialog'
import ArrayStore from 'devextreme/data/array_store';
import { cat } from 'shelljs'
const customRange = {
  getMessage (field, args) {
    let arr = (args + '').split(',')
    if (arr.length === 2) {
      let min = parseFloat(arr[0])
      let max = parseFloat(arr[1])
      return `Value of the field ${field} should be between ${min} and ${max}`
    }
    return `Check validator for a field ${field}`
  },
  validate (value, args) {
    let arr = (args + '').split(',')
    if (arr.length === 2) {
      let v = parseFloat(value + '')
      let min = parseFloat(arr[0])
      let max = parseFloat(arr[1])
      // console.log(`value: ${JSON.stringify(v)} min: ${JSON.stringify(min)} max: ${JSON.stringify(max)}`)
      if (v >= min && v <= max) {
        return true
      }
    }
    return false
  }
}
Validator.extend('customRange', customRange)

export default {
  name: 'mGaugeRunReport',
  components: {
    loading,
    DxTextBox,
    DxSlider,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox,
    cSwitch,
    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxButton,
    DxList,
    DxItemDragging,
    DxTagBox,
    'drag': Drag,
    'drop': Drop
  },
  created () {
    this.Init()
  },
  data () {
    let self = this
    let schedulerObj = {
      MGAUGE_SCHEDULER_ID: 0,
      DEALERSHIP_ID: 0,
      SCHEDULE: [],
      SCHEDULE_HASH: '',
      SCHEDULE_EMAIL: [],
      IS_ACTIVE: false,
      newDate: 1,
      newTime: new Date(),
      newEmail: '',
      clear: function () {
        this.MGAUGE_SCHEDULER_ID = 0
        this.DEALERSHIP_ID = 0
        this.IS_ACTIVE = false
        this.SCHEDULE.splice(0)
        this.SCHEDULE_HASH = ''
        this.SCHEDULE_EMAIL.splice(0)
        this.newDate = 1
        this.newTime = new Date()
        this.newEmail = ''
      },
      title: '',
      use24format: false,
      ButtonSave: {
        text: 'Save',
        stylingMode: 'outlined',
        type: 'success',
        onClick: function (e) {
          self.SchedulerSaveClick()
        }
      },
      ButtonCancel: {
        text: 'Cancel',
        stylingMode: 'outlined',
        type: 'danger',
        onClick: function (e) {
          self.SchedulerBackClick()
        }
      },
      schedulerVisible: false,
      AvailableDates: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
    }
    return {
      CategoryEditionActive: { CategoryId: -1, status: 'none' },
      ToggleEdition: false,
      user: {},
      ReportAvailableColumns: [],
      ReportAvailableColumnsCheckbox: false,
      ReportSelectedColumns: [],
      mGaugeReportColumnsAll: {},
      ReportSelectedColumnsCheckbox: false,
      UseReportDefaultColumns: false,
      IsModalTimeZoneWarningHandleOKPressed: false,
      mGauge_Max_Scans: 0,
      CurrentmGaugeReports: 0,
      mGaugeSupressScan: false,
      mGauge_Categories: [],
      ReportHistoryCategories: [],
      mGauge_Fature_Values: [],
      scheduler: schedulerObj,
      SelectedTemplateID: -1,
      SelectedTemplate: null,
      errMsg: '',
      initLoad: true,
      displayingData: false,
      changesSaved: true,
      canRunReport: false,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      lenderSearch: '',
      wizardStep: 0,
      wizardStepToChange: 0,
      filteredReports: [],
      SelectedReports: [],
      TransferCategories: [],
      filteredRunReports: [],
      OrderAvailableColumns: [
        { text: 'Spread $', value: 0 },
        { text: 'Spread %', value: 1 },
        { text: 'Payment Value Index (PVI)', value: 3 },
        { text: 'Best Payment', value: 5 },
        { text: 'MSRP', value: 4 },
        { text: 'Vehicle (Year, Make, Model, Trim)', value: 2 },
      ],
      OrderSelectedColumns: [],
      data: {},
      MoveCategory: {},
      NewCategory: '',
      IsAllSelection: false,
      searchValue: '',
      // wizardBackStepClicked: false,
      vehicleSets: [],
      activeReport: {},
      reports: [],
      annualMileageOptions: [
        { text: '2,500', value: '2500' },
        {text: '5,000', value: '5000'},
        {text: '7,500', value: '7500'},
        { text: '10,000', value: '10000' },
        { text: '10,500', value: '10500' },
        { text: '12,000', value: '12000' },
        { text: '13,500', value: '13500' },
        { text: '15,000', value: '15000' },
        { text: '16,500', value: '16500' },
        { text: '18,000', value: '18000' },
        { text: '19,500', value: '19500' }
      ],
      showCustomMileage: false,
      scanModeOptions: [
        {text: 'Lease', value: 0},
        {text: 'Retail', value: 1}
      ],
      scanModeSelect: [
        { text: 'All', value: 'All' },
        { text: 'Lease', value: 'Lease' },
        { text: 'Retail', value: 'Retail' }
      ],
      scanMode: 'All',
      scanTypeOptions: [
        {text: 'Profit', value: 1},
        {text: 'Selling Price', value: 0}
      ],
      displayProgramOptions: [
        { text: 'Special and Standard', value: 0 },
        { text: 'Special Only', value: 1 },
        { text: 'Standard Only', value: 2 }
      ],
      titleState: null,
      new_title: 'New Report',
      blankReport: {
        id: -1,
        title: '',
        vehicleSet: null,
        zipCode: null,
        creditScore: '720',
        cashDown: null,
        annualMileage: '15000',
        cashType: 0,
        scanMode: 0,
        scanType: 0,
        displayProgramOption: 0,
        sortBy: 1,
        groupBy: 0,
        adjustmentType: 0,
        adjustmentValueType: 0,
        adjustmentValue: null,
        outputType: [1, 2, 3],
        includeOnlyTermsWithTrackedLenderPresent: false,
        useAverageReport: false,
        applicableCaptiveLender: false,
        terms: [],
        trackedLender: null,
        comparedLenders: [],
        rebateOptions: [],
        useTargetAcquisition: true,
        targetAcquisition: {
          significantDigits: 2,
          raiseRatePercentInRoll: 50,
          lowerRatePercentInRoll: 50,
          targetPayment: null,
          targetPaymentType: 0,
          raiseResidualPctAdj: 20,
          lowerResidualPctAdj: undefined,
          raiseMoneyFactor: undefined,
          lowerMoneyFactor: undefined,
          raiseInterestRate: undefined,
          lowerInterestRate: undefined,
          lowerMaintainRatiosAtLimits: false,
          raiseMaintainRatiosAtLimits: false
        }
      },
      accessAverageReportOnly: false,
      retailTerms: ['12', '18', '24', '30', '36', '42', '48', '54', '60', '63', '66', '72', '75', '78', '84', '88', '90', '96'],
      leaseTerms: ['12', '15', '18', '21', '24', '25', '26', '27', '28', '30', '31', '32', '33', '34', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '48', '49', '50', '51', '52', '54', '57', '60', '66', '72'],
      availableLenders: []
    }
  },
  methods: {
    Init () {
      this.boolLoading = true
      axios.post('/api/mgauge/getmgaugetemplateinitial')
        .then(response => {
          this.boolLoading = false
          this.initLoad = false
          this.accessAverageReportOnly = response.data.accessAverageReportOnly
          this.CurrentmGaugeReports = response.data.scansCount
          this.vehicleSets = response.data.vehicleSets
          this.availableLenders = response.data.lenders
          this.mGauge_Fature_Values = response.data.mgaugeFeatures
          var mGaugeMaxScan = this.mGauge_Fature_Values.filter(x => x['CODE'] === 'MGAUGEMAXSCAN')
          var mGaugeSupressScan = this.mGauge_Fature_Values.filter(x => x['CODE'] === 'MGAUGESUPRMAXSCAN')
          if (mGaugeMaxScan.length > 0 && mGaugeSupressScan.length > 0) {
            this.mGauge_Max_Scans = mGaugeMaxScan[0].PROPERTY_VALUE
            if (mGaugeSupressScan[0].PROPERTY_VALUE === 'True' || this.mGauge_Max_Scans == null) { this.mGaugeSupressScan = true } else { this.mGaugeSupressScan = false }
          }
          //this.GetReportAvailableColumns();
          this.getmGaugeReportColumnsAll();
          this.createReportTemplate()
          this.LoadReportHistoryCategories()
          this.loadtemplatecategories(-1)
          this.wizardStep = 0
          this.initLoad = true
          this.changesSaved = true
          this.Folders = [{ 'value': 1, 'text': 'Current Category' }, { 'value': 2, 'text': 'All Categories' }]
          this.SelectedFolder = this.Folders[0].value
          this.UNASSIGNED = 1
          this.FAVORITES = 2
          this.ARCHIVES = 3

          this.UNASSIGNED_HISTORY = 4

          let self = this
          window.addEventListener('keydown', self.HandleTestValues)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    onUpdate: function (event) {
      console.log('event', event)
    },
    handleDropCustom (category, data, event) {
      if (typeof data !== 'undefined') {
        var reports = []
        reports.push(data)
        if (reports.length === 0) {
          if (category.CategoryId !== data.Category_Id) { this.moveReportToCategory(data, category.CategoryId) } else { alert('Please do not drop the selection in the same category!') }
        } else {
          this.moveSelectedReportsToCategory(reports, category.CategoryId)
        }
      }
    },
    handleDropCustomColumn(droppedColumn, draggedColumn, event) {
      if (typeof draggedColumn !== 'undefined') {
        let temp = {
          'id': draggedColumn.id,
          'columnName': draggedColumn.columnName,
          'isChecked': draggedColumn.isChecked
        }

        draggedColumn.id = droppedColumn.id;
        draggedColumn.columnName = droppedColumn.columnName;
        draggedColumn.isChecked = droppedColumn.isChecked;

        droppedColumn.id = temp.id;
        droppedColumn.columnName = temp.columnName;
        droppedColumn.isChecked = temp.isChecked;

      }
    },

    handleDropCustomSort (template, data, event) {
      if (typeof data !== 'undefined') {
        if (template.TemplateID === data.TemplateID) { return }
        //if (template.CategoryName === 'Unassigned') {
        //  alert('Unassiged category is not sortable')
        //  return
        //}
        let result = confirm('This will save the changes you have made. Are you sure?', 'Confirmation')
        result.then((dialogResult) => {
          if (dialogResult) {
            var objSourceDestiny = {
              TemplateID_Source: data.TemplateID,
              TemplateID_Destiny: template.TemplateID
            }

            this.ReplacemGaugeTemplateOrder(objSourceDestiny)
          }
        })
      }
    },
    onShownAddEditTemplate () {
      if (this.ToggleEdition) {
        this.wizardNextStep(6, 'Step6')
        this.ToggleEdition = false
      }
      this.changesSaved = true
    },
    hideAddEditTemplate () {
      this.changesSaved = true
    },
    getAvailableSelected() {
      console.log("OrderAvailableColumns", this.OrderAvailableColumns)
    },
    getSelectedItemKeys() {
      console.log("selectedItemKeys", this.selectedItemKeys);
    },
    openEditionForm (TemplateID) {
      // this.getCurrent();
      
      if (TemplateID !== -1) {
        this.SelectedTemplateID = TemplateID
        this.editReportTemplate(this.SelectedTemplateID)
        this.toggleModal = true
        this.$refs.AddEditTemplate.show()
      } else {
        this.createReportTemplate()
        this.toggleModal = true
        this.$refs.AddEditTemplate.show()
      }
      this.changesSaved = true
    },
    openToggleEditionForm (TemplateID) {
      this.ToggleEdition = true
      if (TemplateID !== -1) {
        this.SelectedTemplateID = TemplateID
        this.editReportTemplate(this.SelectedTemplateID)
        this.toggleModal = true
        this.$refs.AddEditTemplate.show()
      }
      this.changesSaved = true
    },

    closeVueRunReports () {
      this.$refs.ViewRunReports.hide()
      this.changesSaved = true;
    },

    openViewRunReportsForm (TemplateID) {
      this.filteredRunReports = []
      this.SelectedTemplateID = TemplateID
      this.viewRunReportTemplate(this.SelectedTemplateID)
      this.$refs.ViewRunReports.show()
    },
    ToggleModal: function () {
      this.$refs.AddEditTemplate.hide()
    },
    showScanAlert () {
      if (this.mGaugeSupressScan) {
        return false
      }
      if (!(this.IsAbleToRunScan())) {
        return true
      }
      return false
    },
    showRunReport() {
      if (this.changesSaved == false) { return false }
      if (this.activeReport.id === -1) { return false }
      if (this.mGaugeSupressScan) {
        return true
      }
      if (parseInt(this.CurrentmGaugeReports) < parseInt(this.mGauge_Max_Scans)) {
        return true
      }
      return false
    },
    IsAbleToRunScan () {
      if (this.mGaugeSupressScan === true) {
        return true
      }
      if (parseInt(this.CurrentmGaugeReports) < parseInt(this.mGauge_Max_Scans)) {
        return true
      }
      return false
    },
    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      if (this.new_title.length > 0) {
        this.handleSubmit()
      }
    },
    handleSubmit () {
      if (!this.$refs.form.checkValidity()) {
        return
      }
      const found = this.filteredReports.find(element => element.title.trim() === this.new_title.trim())
      if (found) {
        this.validateErrors.add({ 'field': 'Report Name', 'scope': 'NewTitle', 'msg': 'Report Name is not unique' })
        return
      }

      this.activeReport.id = -1
      this.scheduler.MGAUGE_SCHEDULER_ID = -1
      this.activeReport.title = this.new_title
      this.new_title = 'New Report'

      this.saveReportTemplate()

      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    },
    resetModal () {
      this.new_title = 'Copy - ' + this.activeReport.title
    },
    SchedulerNth (val) {
      let d = parseInt(val + '')
      if (d > 3 && d < 21) {
        return 'th'
      }
      switch (d % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    },

    SchedulerOnTimeValueChanged (e) {
      let self = this
      let k = -1
      for (let i = 0; i < self.scheduler.SCHEDULE.length; i++) {
        if (self.scheduler.SCHEDULE[i].times.length === 0) {
          k = i
          break
        }
      }
      if (k !== -1) {
        self.scheduler.SCHEDULE.splice(k, 1)
      }
      this.changesSaved = false
    },
    CreateSchedulerTime (time) {
      let strTime = moment(time).format('HH:mm')
      return strTime
    },
    CreateSchedulerItem (date, time) {
      let self = this
      let obj = {
        'date': date,
        'times': []
      }
      obj.times.push(self.CreateSchedulerTime(time))
      return obj
    },
    /**
       * @return {string}
       */
    SchedulerItemFormat (e) {
      let self = this
      let rr = `${moment().format('YYYY-MM-DD')} ${e}`
      if (self.scheduler.use24format) {
        return moment(rr, 'YYYY-MM-DD HH:mm').format('HH:mm')
      } else {
        return moment(rr, 'YYYY-MM-DD HH:mm').format('h:mm A')
      }
    },
    SchedulerItemClick (e) {
      let self = this
      self.scheduler.newDate = e.itemData.date
    },
    SchedulerAddEmail (e) {
      let self = this
      let email = self.scheduler.newEmail
      let target = self.scheduler.SCHEDULE_EMAIL.find(r => r === email)
      if (target === undefined) {
        self.scheduler.SCHEDULE_EMAIL.push(email)
        self.scheduler.newEmail = ''
      }
      self.changesSaved = false
    },
    SchedulerAddDateTimeClick () {
      let self = this
      // console.log(`newDate: ${self.scheduler.newDate} newTime: ${self.scheduler.newTime}`)
      let target = self.scheduler.SCHEDULE.find(r => r.date === self.scheduler.newDate)
      if (target === undefined) {
        self.scheduler.SCHEDULE.push(self.CreateSchedulerItem(self.scheduler.newDate, self.scheduler.newTime))
      } else {
        let time = self.CreateSchedulerTime(self.scheduler.newTime)
        let targetTime = target.times.find(r => r === time)
        if (targetTime === undefined) {
          target.times.push(time)
        }
      }
      self.SchedulerSort()
      self.changesSaved = false
      // console.log(`SelectedValues: ${JSON.stringify(self.scheduler.SCHEDULE)}`)
    },
    SchedulerSort () {
      let self = this
      if (self.scheduler.SCHEDULE !== undefined && self.scheduler.SCHEDULE.length > 0) {
        self.scheduler.SCHEDULE.sort((a, b) => a.date - b.date)
        for (let i = 0; i < self.scheduler.SCHEDULE.length; i++) {
          self.scheduler.SCHEDULE[i].times.sort((a, b) => parseInt(a.replace(':', '')) - parseInt(b.replace(':', '')))
        }
      }
    },
    SchedulerOpenClick () {
      // console.log('schedule clicked')
      let self = this
      self.scheduler.title = `Set schedule for report "${self.activeReport.title}" `
      self.scheduler.schedulerVisible = true
    },
    SchedulerSaveClick () {
      // console.log('SAVE schedule clicked')
      let self = this
      // self.scheduler.schedulerVisible = false
      self.SchedulerSave(self.scheduler.MGAUGE_SCHEDULER_ID, self.scheduler.DEALERSHIP_ID,
        JSON.stringify(self.scheduler.SCHEDULE), self.activeReport.id, self.scheduler.SCHEDULE_EMAIL.join(';'))
    },
    SchedulerBackClick () {
      // console.log('Back from schedule clicked')
      let self = this
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          self.scheduler.schedulerVisible = false
        }
      })
    },
    SchedulerLoad (TEMPLATE_ID) {
      let self = this
      // console.log(`Scheduler LOAD ... TEMPLATE_ID ${TEMPLATE_ID}`)
      let obj = {
        'TEMPLATE_ID': TEMPLATE_ID
      }
      axios.post('/api/mgauge/GetSchedule', obj)
        .then(response => {
          if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
            if (response.data !== undefined) {
              // console.log(`SchedulerLoad ${JSON.stringify(response)}`)
              self.scheduler.MGAUGE_SCHEDULER_ID = parseInt(response.data.MGAUGE_SCHEDULER_ID + '')
              self.scheduler.DEALERSHIP_ID = parseInt(response.data.DEALERSHIP_ID + '')
              self.scheduler.IS_ACTIVE = response.data.IS_ACTIVE
              let SCHEDULE_EMAIL_FROMDB = response.data.SCHEDULE_EMAIL
              if (SCHEDULE_EMAIL_FROMDB === undefined || SCHEDULE_EMAIL_FROMDB === null) {
                SCHEDULE_EMAIL_FROMDB = ''
              }
              let arrEmail = SCHEDULE_EMAIL_FROMDB.split(';').filter(x => x.length > 0)
              if (arrEmail instanceof Array) {
                self.scheduler.SCHEDULE_EMAIL.splice(0)
                for (let f = 0; f < arrEmail.length; f++) {
                  self.scheduler.SCHEDULE_EMAIL.push(arrEmail[f])
                }
              }

              let arr = JSON.parse(response.data.SCHEDULE)
              if (arr instanceof Array) {
                self.scheduler.SCHEDULE.splice(0)
                for (let f = 0; f < arr.length; f++) {
                  self.scheduler.SCHEDULE.push(arr[f])
                }
                self.SchedulerSort()
              }
              self.scheduler.SCHEDULE_HASH = response.data.SCHEDULE_HASH
              /* console.log(`
              MGAUGE_SCHEDULER_ID ${JSON.stringify(self.scheduler.MGAUGE_SCHEDULER_ID)}
              DEALERSHIP_ID ${JSON.stringify(self.scheduler.DEALERSHIP_ID)}
              SCHEDULE ${JSON.stringify(self.scheduler.SCHEDULE)}
              SCHEDULE_HASH ${JSON.stringify(self.scheduler.SCHEDULE_HASH)}
              SCHEDULE_EMAIL ${JSON.stringify(self.scheduler.SCHEDULE_EMAIL)}
              `) */
            }
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    GetReportAvailableColumns() {
      console.log("GetReportAvailableColumns");
      let self = this
      //var resquestbody = {
      //  scanMode: self.activeReport.scanMode,
      //  useTargetAcquisition: self.activeReport.useTargetAcquisition,
      //  groupBy: self.activeReport.groupBy,
      //  generateAverageByModelNoTrim: self.activeReport.useAverageReport
      //}
      axios.post('/api/mgauge/getreporttemplateavailablecolumns', self.activeReport)
        .then(response => {
          if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
            if (response.data !== undefined) {
              //console.log("response.data", response.data);
              self.ReportAvailableColumns = [];
              self.setAvailableReportColumns(response.data);
            }
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    getmGaugeReportColumnsAll() {
      let self = this
      axios.post('/api/mgauge/getmgaugereportcolumnsall', self.activeReport)
        .then(response => {
          if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
            if (response.data !== undefined) {
              self.mGaugeReportColumnsAll = response.data;

            }
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    addSelectedToAvailable() {
      let self = this;
      let selectedAvailable = self.getCurrentColumnSelected(self.ReportSelectedColumns)
      self.ReportAvailableColumns.push(...selectedAvailable)
      self.ReportSelectedColumns = self.removeReporColumn(self.ReportSelectedColumns, selectedAvailable)
      self.ReportAvailableColumns = self.arraySortObject(self.ReportAvailableColumns, 'id');
      self.changesSaved = false
    },
    arraySortObject(ArrayElements, FieldName) {
      return ArrayElements.sort((a, b) => { return a[FieldName] - b[FieldName] });
    },
    addAvailableToSelected() {
      let self = this;
      let selectedAvailable = self.getCurrentColumnSelected(self.ReportAvailableColumns)
      self.ReportSelectedColumns.push(...selectedAvailable)
      self.ReportAvailableColumns = self.removeReporColumn(self.ReportAvailableColumns, selectedAvailable)
      self.changesSaved = false
    },   
    setAvailableReportColumns(ReportColumns) {
      let self = this;
      //console.log("ReportAvailableColumns in setAvailableReportColumns", self.ReportAvailableColumns)
      //console.log("ReportColumns in setAvailableReportColumns", ReportColumns)
      self.ReportAvailableColumns = ReportColumns.map((column,index) => {
        const item = { 'id': index, 'columnName': column, isChecked: false };
        return item;
      })

      //self.ReportSelectedColumns = self.ReportSelectedColumns.map((column, index) => {
      //  const item = { 'id': index, 'columnName': column, isChecked: false };
      //  return item;
      //})

      //console.log("self.ReportSelectedColumns",self.ReportSelectedColumns)

      //console.log("self.ReportAvailableColumns in setAvailableReportColumns", self.ReportAvailableColumns)
      var ColsNotInAvailables = self.getSelectedColumnsNotInAvailableColumns(self.ReportSelectedColumns);
      //console.log("Implemented ColsNotInAvailables", ColsNotInAvailables )
      
      self.ReportSelectedColumns = self.excludeColumnsNotInAvailablesfromSelectedColumns(self.ReportSelectedColumns, ColsNotInAvailables);
      //console.log("self.ReportSelectedColumns", self.ReportSelectedColumns)
      self.setColumnSelected(self.ReportSelectedColumns)
    },
    excludeColumnsNotInAvailablesfromSelectedColumns(ReportSelectedColumns, ColsNotInAvailables) {
      var res = ReportSelectedColumns.filter(column => {
        return ColsNotInAvailables.filter(x => x.columnName === column.columnName).length == 0
      });
      return res;
    },
    setColumnSelected(SelectedColumns) { //ReportSelectedColumns
      let self = this;
      
      var res = self.ReportAvailableColumns.filter(column => {
        return SelectedColumns.filter(x => x.columnName === column.columnName).length == 0
      });
      self.ReportAvailableColumns = res;      
    },
    getSelectedColumnsNotInAvailableColumns(SelectedColumns) { //ReportSelectedColumns
      let self = this;
      var res = SelectedColumns.filter(column => {
        return self.ReportAvailableColumns.filter(x => x.columnName === column.columnName).length == 0
      });
      return res;
    },

    removeReporColumn(ReportColumnArray,ReportColumnsToRemove) {
      return ReportColumnArray.filter(x => {
        return !(ReportColumnsToRemove.filter(el => el.columnName === x.columnName).length>0)
      });
    },
    
    setReportColumnSelectedValue(ReportColumnArray,IsChecked) {
      ReportColumnArray.forEach(x => {
        x.isChecked = !IsChecked;
      });
      return ReportColumnArray;
    },
    getCurrentColumnSelected(ReportColumnArray) {
      let currentSelectedColumns = [];
      ReportColumnArray.forEach(x => {
        if (x.isChecked )
          currentSelectedColumns.push(x);
      });
      return currentSelectedColumns;
    },

    SchedulerSave (MGAUGE_SCHEDULER_ID, DEALERSHIP_ID, SCHEDULE, TEMPLATE_ID, SCHEDULE_EMAIL, IS_ACTIVE) {
      let self = this
      // console.log(`Scheduler SAVE ... TEMPLATE_ID ${TEMPLATE_ID}`)
      let obj = {
        'MGAUGE_SCHEDULER_ID': MGAUGE_SCHEDULER_ID,
        'DEALERSHIP_ID': DEALERSHIP_ID,
        'SCHEDULE': SCHEDULE,
        'TEMPLATE_ID': TEMPLATE_ID,
        'SCHEDULE_EMAIL': SCHEDULE_EMAIL,
        'IS_ACTIVE': IS_ACTIVE
      }

      // console.log(`obj 2 SAVE ${JSON.stringify(obj)}`)

      axios.post('/api/mgauge/SaveSchedule', obj)
        .then(response => {
          // console.log(`SchedulerLoad ${JSON.stringify(response)}`)
          self.SchedulerLoad(TEMPLATE_ID)
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
        })
    },
    customItemCreating (data) {
      if (!data.text || isNaN(data.text)) {
        data.customItem = null
        return
      }

      let amOption = {text: data.text, value: data.text.replace(',', '')}
      this.annualMileageOptions.push(amOption)
      data.customItem = amOption
    },
    selectallLeaseTerms (SelectAll) {
      let self = this
      self.activeReport.terms.splice(0)
      if (SelectAll) {
        self.leaseTerms.forEach(function (i) {
          self.activeReport.terms.push(i)
        })
      }
    },
    selectallRetailTerms (SelectAll) {
      let self = this
      self.activeReport.terms.splice(0)
      if (SelectAll) {
        self.retailTerms.forEach(function (i) {
          self.activeReport.terms.push(i)
        })
      }
    },
    loadtemplatecategories (SelectedCategoryId) {
      axios.get('/api/mgauge/loadtemplatecategories')
        .then(response => {
          this.boolLoading = false

          this.mGauge_Categories = response.data

          if (SelectedCategoryId !== -1) {
            var cats = this.mGauge_Categories.filter(x => x.CategoryId === SelectedCategoryId)
            if (cats.length > 0) { this.SelectedCategory = cats[0] }
          } else {
            this.SelectedCategory = this.mGauge_Categories[0]
          }
          this.SetActiveCategory(this.SelectedCategory)
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    loadReportTemplates () {
      axios.get('/api/mgauge/loadtemplatecategories')
        .then(response => {
          this.boolLoading = false
          this.data = response.data;
          this.filteredReports = this.SelectedReports = response.data.Unassigned.Templates; //response.data.data
          this.SelectedCategory = this.data.Unassigned;
          this.setTransferCategories(this.data);
          this.accessAverageReportOnly = response.data.accessAverageReportOnly
          this.getFeatureValues();
          this.changesSaved = true
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    async LoadReportHistoryCategories () {
      let self = this
      try {
        let response = await axios.get('/api/mgauge/loadreporthistorycategories?templatetypeid=' + self.templatetypeid)
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined) {
            console.log(`loadhistory ${self.templatetypeid}`)
            self.ReportHistoryCategories = response.data
            self.boolLoading = false
            if (self.ReportHistoryCategories.length > 0) {
              self.ReportCategory = self.ReportHistoryCategories[0]
            }
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }
    },
    AddCustomCategory () {
      let self = this
      let StaticCategories = 3
      if (!(self.NewCategory !== null && self.NewCategory.length > 0)) {
        this.errMsg = 'The Category Name is empty'
        this.showDismissibleAlert = true
        return
      }
      if (self.mGauge_Categories.filter(x => x.CategoryName === self.NewCategory).length === 0) {
        let result = confirm('This will save the changes you have made. Are you sure?', 'Confirmation')
        result.then((dialogResult) => {
          if (dialogResult) {
            const CustomCategory = {
              'CategoryId': -1,
              'CategoryTypeId': 1,
              'CategoryName': self.NewCategory
            }

            self.NewCategory = ''
            this.SaveTemplateCategoryChanges(CustomCategory)
          }
        })
      } else {
        this.errMsg = 'The Category Name is already in the list'
        this.showDismissibleAlert = true
      }
    },
    SaveTemplateCategoryChanges (CustomCategory) {
      axios.post('/api/mgauge/savemgaugecategory', CustomCategory)
        .then(response => {
          this.clearEditionCategory()
          this.boolLoading = false
          this.initLoad = false
          this.loadtemplatecategories(-1)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    DeleteCategory (CustomCategory) {
      axios.post('/api/mgauge/deletemgaugecategory', CustomCategory)
        .then(response => {
          if (response.data.error !== undefined) {
            this.errMsg = response.data.error
            this.showDismissibleAlert = true
          }
          this.boolLoading = false
          this.initLoad = false
          this.loadtemplatecategories(-1)
        })
        .catch(error => {
          console.log('error', error)
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    ReplacemGaugeTemplateOrder (objSourceDestiny) {
      axios.post('/api/mgauge/replacemgaugetemplateorder', objSourceDestiny)
        .then(response => {
          if (response.data.error !== undefined) {
            this.errMsg = response.data.error
            this.showDismissibleAlert = true
          }
          this.boolLoading = false
          this.initLoad = false
          this.SetActiveCategory(this.SelectedCategory)
        })
        .catch(error => {
          console.log('error', error)
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    selectAll () {
      if (this.IsAllSelection === true) {
        for (var i = 0; i < this.filteredReports.length; i++) {
          var element = this.filteredReports[i]
          element['IsSelected'] = true
        }
      } else {
        for (var i = 0; i < this.filteredReports.length; i++) {
          var element = this.filteredReports[i]
          element['IsSelected'] = false
        }
      }
    },
    archiveCategory (category) {
      let result = confirm("All Templates will be moved to the 'Archive' Section. Are you sure Y/N", 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.get('/api/mgauge/Loadmgaugetemplates?CategoryId=' + category.CategoryId)
            .then(response => {
              this.boolLoading = false
              var reports = response.data
              this.MoveReportsToArchiveAndDeleteCategory(reports, category)
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }
              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        }
      })
    },
    MoveReportsToArchiveAndDeleteCategory (SelectedElements, categoryFrom) {
      console.log('SelectedElements', SelectedElements)
      var CategoryTypeId = 1 // Template
      var IDS = SelectedElements.map(function (element, index, array) {
        return element.TemplateID
      })

      var ArchiveCategoryId = 3
      var TransferObject = {
        SelectedElements: IDS,
        CategoryIdTo: ArchiveCategoryId,
        CategoryTypeId: CategoryTypeId
      }
      axios.post('/api/mgauge/transfermgaugetemplates', TransferObject)
        .then(response => {
          this.DeleteCategory(categoryFrom)
          this.loadtemplatecategories(ArchiveCategoryId)
          this.boolLoading = false
          this.changesSaved = true
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },

    setToEditCategory (category) {
      console.log('CategoryEditionActive category', category)
      this.CategoryEditionActive = {
        CategoryId: category.CategoryId,
        status: 'started',
        CategoryName: category.CategoryName
      }
      this.SetActiveCategory(category)
    },
    saveEditionCategory (category) {
      this.SaveTemplateCategoryChanges(this.CategoryEditionActive)
    },
    ExistNameInCategory (Name, ExcludingId) {
      return this.mGauge_Categories.filter(x => x.CategoryName === Name && x.CategoryId !== ExcludingId).length > 0
    },
    confirmSaveCategory (category) {
      if (category.CategoryName !== this.CategoryEditionActive.CategoryName) {
        if (this.ExistNameInCategory(this.CategoryEditionActive.CategoryName, this.CategoryEditionActive.CategoryId)) {
          alert('Duplicate Category Name!', 'Error')
          return
        }
        let result = confirm('A category has been modified. Do you want to save the change? Y/N', 'Confirmation')
        result.then((dialogResult) => {
          if (dialogResult) {
            this.saveEditionCategory(category)
          } else {
            this.clearEditionCategory()
          }
        })
      }
    },
    clearEditionCategory () {
      this.CategoryEditionActive = {
        CategoryId: -1,
        status: 'none',
        CategoryName: ''
      }
    },
    moveReportToFavorites (report) {
      let result = confirm('Are you sure you want to make the following change? NOTE: The report will be moved to the Category Assign.')
      result.then((dialogResult) => {
        if (dialogResult) {
          var SelectedElements = []
          SelectedElements.push(report)
          this.MoveSelectedReportsToDifferentCategory(SelectedElements, report.Category_Id, this.FAVORITES)
        }
      })

    },
    moveReportToArchive (report) {
      var result = confirm("This template will be moved to the 'Archive' Section. Are you sure Y/N", 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          var SelectedElements = []
          SelectedElements.push(report)
          this.MoveSelectedReportsToDifferentCategory(SelectedElements, report.Category_Id, this.ARCHIVES)
        }
      })
    },
    moveSelectionToCategory () {
      let result = confirm('Are you sure you want to make the following change? NOTE: The report(s) will be moved to the Category Assign.')
      result.then((dialogResult) => {
        if (dialogResult) {
          var SelectedElements = []
          this.SelectedReports.filter(x => this.IsSelected(x)).forEach(function (report) {
            SelectedElements.push(report)
          })
          this.MoveSelectedReportsToDifferentCategory(SelectedElements, this.SelectedCategory.CategoryId, this.MoveCategory)
        }
      })
    },
    moveSelectedReportsToCategory (SelectedElements, CategoryIdToMove) {
      let result = confirm('Are you sure you want to make the following change? NOTE: The template(s) will be moved to the assigned Category.')
      result.then((dialogResult) => {
        if (dialogResult) {
          if (SelectedElements.length > 0) { this.MoveSelectedReportsToDifferentCategory(SelectedElements, SelectedElements[0].Category_Id, CategoryIdToMove) }
        }
      })
    },
    moveReportToCategory (report, CategoryIdToMove) {
      let result = confirm('Are you sure you want to make the following change? NOTE: The template will be moved to the Category Assign.')
      result.then((dialogResult) => {
        if (dialogResult) {
          var SelectedElements = []
          SelectedElements.push(report)
          this.MoveSelectedReportsToDifferentCategory(SelectedElements, this.SelectedCategory.CategoryId, CategoryIdToMove)
        }
      })
    },

    IsSelected (report) {
      return (typeof report['IsSelected'] !== 'undefined' && report.IsSelected === true)
    },
    MoveSelectedReportsToDifferentCategory (SelectedElements, CategoryIdFrom, CategoryIdTo) {
      var CategoryTypeId = 1 // Template
      var IDS = SelectedElements.map(function (element, index, array) {
        return element.TemplateID
      })

      var TransferObject = {
        SelectedElements: IDS,
        CategoryIdFrom: CategoryIdFrom,
        CategoryIdTo: CategoryIdTo,
        CategoryTypeId: CategoryTypeId
      }
      axios.post('/api/mgauge/transfermgaugetemplates', TransferObject)
        .then(response => {
          this.loadtemplatecategories(TransferObject.CategoryIdFrom)
          this.boolLoading = false
          this.changesSaved = true
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    SetActiveCategory (category) {
      if (category.CategoryId !== this.CategoryEditionActive.CategoryId) {
        this.clearEditionCategory()
      }
      this.SelectedCategory = category
      axios.get('/api/mgauge/Loadmgaugetemplates?CategoryId=' + category.CategoryId)
        .then(response => {
          this.boolLoading = false
          this.filteredReports = this.SelectedReports = response.data
          this.TransferCategories = this.mGauge_Categories.filter(x => x.CategoryId !== this.SelectedCategory.CategoryId)
          this.changesSaved = true
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    IsCategorySelected (CategoryId) {
      return CategoryId === this.SelectedCategory.CategoryId
    },
    addReportsTo (reports, ReportHistoryCategoryArrayDestiny, CategoryIdTo) {
      reports.forEach(function (report) {
        report.categoryId = CategoryIdTo
        report.JObjectContent.CategoryId = CategoryIdTo
        ReportHistoryCategoryArrayDestiny.Templates.push(report)
      })
    },
    // removeReportsFrom(SelectedReports, ReportHistoryCategoryArraySource) {
    //  var ids = [];
    //  SelectedReports.forEach(function (template) {
    //    for (var i = 0; i < ReportHistoryCategoryArraySource.Templates.length; i++) {
    //      if (ReportHistoryCategoryArraySource.Templates[i].TemplateID == template.TemplateID) {
    //        var TemplateID = template.TemplateID;
    //        ids.push(TemplateID);
    //        ReportHistoryCategoryArraySource.Templates.splice(i, 1);
    //        break;
    //      }
    //    }
    //  });
    //  this.RemoveFromSelectedReport(ids);
    // },
    // RemoveFromSelectedReport(report_ids) {
    //  for (var j = 0; j < report_ids.length; j++) {
    //    for (var x = 0; x < this.SelectedReports.length; x++) {
    //      if (this.SelectedReports[x].TemplateID == report_ids[j]) {
    //        this.SelectedReports.splice(x, 1);
    //        break;
    //      }
    //    }
    //  }
    // },
    searchReport () {
      let self = this

      if (this.SelectedFolder === 1) {
        self.filteredReports = self.SelectedReports.filter(x =>
          x.title.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1 ||
          x.TemplateID === ('' + self.searchValue) || // x.id == ('' + self.searchValue) ||
          x.VSetTitle.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1
        )
      } else { // TODO: Work with api cal
        self.filteredReports = self.getAllFolders().filter(x =>
          x.title.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1 ||
          x.TemplateID === ('' + self.searchValue) ||
          x.VSetTitle.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1
        )
      }

      if (self.scanMode !== 'All') {
        self.filteredReports = self.filteredReports.filter(x => x.scanMode === self.scanMode)
      }
    },
    DownloadReport (download) {
      this.boolLoading = true
      const options = {
        method: 'POST',
        data: download,
        responseType: 'blob',
        url: '/api/mgauge/downloadreport'
      }
      axios(options)
        .then(response => {
          this.boolLoading = false
          let fileName = response.headers['content-disposition'].split('filename=')[1]
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1])
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    async createReportTemplate () {
      let self = this
      self.$validator.reset()
      self.initLoad = false
      try {
        let response = await axios.post('/api/mgauge/getdefaulttemplate', null)
        if (response !== null && response !== undefined) {
          self.activeReport = response.data
          self.activeReport.vehicleSet = String(self.activeReport.vehicleSet)
          self.ReportSelectedColumns = self.activeReport.ReportSelectedColumns = []
          self.UseReportDefaultColumns = self.activeReport.UseReportDefaultColumns = true
          self.setComlumnReports();
        }
      }
      catch(error) {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
      }
      // self.activeReport = JSON.parse(JSON.stringify(this.blankReport))
      if (self.accessAverageReportOnly) {
        self.activeReport.useAverageReport = true
        self.activeReport.useTargetAcquisition = false
      }

      if (self.activeReport.CategoryId === undefined) { self.activeReport.CategoryId = this.UNASSIGNED }
            
      if (self.activeReport.DefaultHistoryCategoryId === undefined) { self.activeReport.DefaultHistoryCategoryId = this.UNASSIGNED_HISTORY }

      self.changesSaved = false
      self.$validator.reset()
      self.wizardStep = 0 

      self.availableLenders.forEach(function (i) {
        let selected = self.activeReport.comparedLenders.filter(s => s.Name === i.Name)
        i.Compared = selected.length > 0        
      })

      self.scheduler.clear()
      await self.trueValidateAllSilent(true)
      self.canRunReport = false
      self.ReportSelectedColumns = [];
      self.setComlumnReportsAssign();
      //self.GetReportAvailableColumns();
    },
    updateComparedLender (lender) {
      let self = this
      self.availableLenders.forEach(item => {
        if (item.Name.toLowerCase() === lender.Name.toLowerCase()) {
          item.Compared = lender.Compared
        }
      })
    },
    CalcRateChange (e) {
      if (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null) {
        if (!this.activeReport.trackedLender.hasMoneyFactor || !this.activeReport.trackedLender.hasInterestRate) { return }
      }
      if (isNaN(e.value) || e === '') { return }

      let changedNumber = parseFloat(e.value)
      let ta = this.activeReport.targetAcquisition

      switch (e.element.id) {
        case 'lowerMoneyFactor':
          if (isNaN(ta.lowerInterestRate) || ta.lowerInterestRate === null) { ta.lowerInterestRate = changedNumber * 2400.0 }
          break
        case 'raiseMoneyFactor':
          if (isNaN(ta.raiseInterestRate) || ta.raiseInterestRate === null) { ta.raiseInterestRate = changedNumber * 2400.0 }
          break
        case 'lowerInterestRate':
          if (isNaN(ta.lowerMoneyFactor) || ta.lowerMoneyFactor === null) { ta.lowerMoneyFactor = parseFloat((changedNumber / 2400.0).toFixed(5)) }
          break
        case 'raiseInterestRate':
          if (isNaN(ta.raiseMoneyFactor) || ta.raiseMoneyFactor === null) { ta.raiseMoneyFactor = parseFloat((changedNumber / 2400.0).toFixed(5)) }
          break
      }
    },
    ScanModeChange () {
      let self = this
      //self.GetReportAvailableColumns();
      if (self.displayingData === false) { self.activeReport.terms = [] }
    },
    async editReportTemplate (reportId) {
      let self = this
      self.initLoad = false
      this.changesSaved = false
      self.wizardStep = 0
      let obj = {}
      obj.id = reportId
      self.displayingData = true
      await axios.post('/api/mgauge/loadreporttemplate', obj)
        .then(response => {
          self.boolLoading = false
          let tempObj = JSON.parse(JSON.stringify(self.blankReport))
          self.activeReport = Object.assign(tempObj, response.data)
          self.activeReport.id = reportId
          if (self.activeReport.CategoryId === undefined) { self.activeReport.CategoryId = this.UNASSIGNED }

        
          if (self.activeReport.DefaultHistoryCategoryId === undefined) { self.activeReport.DefaultHistoryCategoryId = this.UNASSIGNED_HISTORY }

          if (self.accessAverageReportOnly) {
            self.activeReport.useAverageReport = true
            self.activeReport.useTargetAcquisition = false
          }

          self.availableLenders.forEach(function (i) {
            i.Compared = false
            if (self.activeReport.trackedLender !== null && self.activeReport.trackedLender.Name === i.Name) {
              self.activeReport.trackedLender = i
            }
          })
          self.activeReport.comparedLenders.forEach(function (i) {
            self.updateComparedLender(i)
          })

          self.setComlumnReports();
          
          self.changesSaved = true
          self.SchedulerLoad(self.activeReport.id)
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })

      self.canRunReport = await self.trueValidateAllSilent()
      self.displayingData = false
    },
    setComlumnReports() {
      let self = this
      //console.log("setComlumnReports self.activeReport", self.activeReport)
      self.ReportSelectedColumns = self.activeReport.ReportSelectedColumns
      self.UseReportDefaultColumns = self.activeReport.UseReportDefaultColumns
      self.setComlumnReportsAssign() 
           
    },
    setComlumnReportsAssign() {
      let self = this
      //console.log("self.mGaugeReportColumnsAll", self.mGaugeReportColumnsAll)
      let columnsfinal = self.getColumnsFromJoin(self.mGaugeReportColumnsAll, self.activeReport.scanMode === 0, self.activeReport.useTargetAcquisition,
        self.activeReport.groupBy, self.activeReport.useAverageReport)
      //console.log("columnsfinal", columnsfinal)
      self.ReportAvailableColumns = columnsfinal.map(column => {
        return column.Description
      })
      //console.log("self.ReportAvailableColumns", self.ReportAvailableColumns)

      self.setAvailableReportColumns(self.ReportAvailableColumns)  
    },
    getColumnsFromJoin(mGaugeReportColumnsAll, isLease, isExtendedTgtAcquisition, groupBy, useAverageReport) {
      let self = this

      //console.log("mGaugeReportColumnsAll", mGaugeReportColumnsAll)
      //console.log("isLease", isLease)
      //console.log("isExtendedTgtAcquisition", isExtendedTgtAcquisition)
      //console.log("groupBy", groupBy)
      //console.log("useAverageReport", useAverageReport)

      let mGaugeReportColumnsSelected=[]
      let mGaugeReportColumnsSelecteds = mGaugeReportColumnsAll.ReportColumnsByTypes.filter(x =>
        x.UseAverageReport === useAverageReport && x.groupBy === groupBy)

      //console.log("mGaugeReportColumnsSelecteds", mGaugeReportColumnsSelecteds)

      if (mGaugeReportColumnsSelecteds.length > 0)
        mGaugeReportColumnsSelected = mGaugeReportColumnsSelecteds[0]
      else {
        // Getting deafult group in case the list return an empty result
        mGaugeReportColumnsSelecteds = mGaugeReportColumnsAll.ReportColumnsByTypes.filter(x =>
          x.UseAverageReport === useAverageReport && x.groupBy === 0)
        if (mGaugeReportColumnsSelecteds.length >0)
          mGaugeReportColumnsSelected = mGaugeReportColumnsSelecteds[0]       
      }
      //console.log("mGaugeReportColumnsSelected", mGaugeReportColumnsSelected)
      //console.log("mGaugeReportColumnsSelected inner", mGaugeReportColumnsSelecteds)

      let mGaugeReportDefaultColumns = mGaugeReportColumnsAll.mGaugeReportDefaultColumns      
      //console.log("mGaugeReportDefaultColumns", mGaugeReportDefaultColumns)

      //console.log("mGaugeReportColumnsSelected.ColumnsGeneral", mGaugeReportColumnsSelected.ColumnsGeneral)
      let ColumnsGeneral = self.getColumnsJoinedColumnDefault(mGaugeReportColumnsSelected.ColumnsGeneral, mGaugeReportDefaultColumns)
      //console.log("ColumnsGeneral", ColumnsGeneral)

      //console.log("mGaugeReportColumnsSelected.ColumnsOnlyLease", mGaugeReportColumnsSelected.ColumnsOnlyLease)
      let ColumnsOnlyLease = self.getColumnsJoinedColumnDefault(mGaugeReportColumnsSelected.ColumnsOnlyLease, mGaugeReportDefaultColumns)
      //console.log("ColumnsOnlyLease", ColumnsOnlyLease)

      let ColumnsOnlyExtendedTgtAcquisition = []
      if (mGaugeReportColumnsSelected.ColumnsOnlyExtendedTgtAcquisition != null) {
        ColumnsOnlyExtendedTgtAcquisition = self.getColumnsJoinedColumnDefault(mGaugeReportColumnsSelected.ColumnsOnlyExtendedTgtAcquisition, mGaugeReportDefaultColumns)
        //console.log("ColumnsOnlyExtendedTgtAcquisition", ColumnsOnlyExtendedTgtAcquisition)
      }
      
      let ColumnsLeaseAndExtendedTgtAcquisition = []
      if (mGaugeReportColumnsSelected.ColumnsLeaseAndExtendedTgtAcquisition) {
        ColumnsLeaseAndExtendedTgtAcquisition = self.getColumnsJoinedColumnDefault(mGaugeReportColumnsSelected.ColumnsLeaseAndExtendedTgtAcquisition, mGaugeReportDefaultColumns)
        //console.log("ColumnsLeaseAndExtendedTgtAcquisition", ColumnsLeaseAndExtendedTgtAcquisition)
      }
      
      let columnsfinal = [];
      columnsfinal = ColumnsGeneral

      if (isLease && !isExtendedTgtAcquisition)
        columnsfinal = columnsfinal.concat(ColumnsOnlyLease)
      else if (!isLease && isExtendedTgtAcquisition)
        columnsfinal = columnsfinal.concat(ColumnsOnlyExtendedTgtAcquisition)
      else if (isLease && isExtendedTgtAcquisition)
        columnsfinal = columnsfinal.concat(ColumnsLeaseAndExtendedTgtAcquisition)

      //console.log("columnsfinal", columnsfinal)

      columnsfinal.sort((a, b) => { return a.Order - b.Order })

      //console.log("columnsfinal sorted", columnsfinal)
      return columnsfinal
      //self.ReportAvailableColumns = []
    },
    getColumnsJoinedColumnDefault(mGaugeReportColumnsSelectedType, mGaugeReportDefaultColumns) {
      //console.log("mGaugeReportColumnsSelectedType in getColumnsJoinedColumnDefault", mGaugeReportColumnsSelectedType)
      let ColumnsLeaseAndExtendedTgtAcquisition = mGaugeReportColumnsSelectedType.map(selectedColumn => {
        const defaultcolumn = mGaugeReportDefaultColumns.find(defaultcolumn => defaultcolumn.id === selectedColumn)
        //if (defaultcolumn == null)
        //  return [];
        return defaultcolumn
      })
      //console.log("ColumnsLeaseAndExtendedTgtAcquisition", ColumnsLeaseAndExtendedTgtAcquisition)
      return ColumnsLeaseAndExtendedTgtAcquisition
    },
    async viewRunReportTemplate (TEMPLATE_ID) {
      let self = this
      self.initLoad = false
      self.wizardStep = 0
      let obj = {}
      obj.TEMPLATE_ID = TEMPLATE_ID
      self.displayingData = true
      await axios.post('/api/mgauge/LoadReportHistory', obj)
        .then(response => {
          self.boolLoading = false
          this.filteredRunReports = response.data
        })
        .catch(error => {
          if (error.response.status === 403) {
            this.$router.push('/login')
          }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })

      self.canRunReport = await self.trueValidateAllSilent()
      self.displayingData = false
    },

    setLegacyTerms () {
      let self = this
      try {
        if (self.activeReport.leaseTerms.length > 0 && self.activeReport.terms.length === 0) {
          for (let i = 0; i < self.activeReport.leaseTerms.length; i++) {
            let term = self.activeReport.leaseTerms[i]
            self.activeReport.terms.push(term.toString())
          }
        }
      } catch (e) {
      }
      try {
        if (self.activeReport.retailTerms.length > 0 && self.activeReport.terms.length === 0) {
          for (let i = 0; i < self.activeReport.retailTerms.length; i++) {
            let term = self.activeReport.retailTerms[i]
            self.activeReport.terms.push(term.toString())
          }
        }
      } catch (e) {
      }
    },
    async saveReportTemplate (hide = true) {
      let self = this

      const found = self.reports.find(element => element.title.trim() === self.activeReport.title.trim() && element.id !== self.activeReport.id)
      if (found) {
        self.validateErrors.add({ 'field': 'Report Name', 'scope': 'Title', 'msg': 'Report Name is not unique' })
        return
      }
      var parseErrors = self.IsSchedulerValid()
      // console.log("parseErrors", parseErrors);      
      if (self.scheduler.IS_ACTIVE===true && self.scheduler.SCHEDULE.length === 0) {
        alert('To enable a schedule, please complete the schedule template.', 'Error')
        self.scheduler.IS_ACTIVE = false
        return
      }

      const isValid = await self.trueValidateAll()
      self.canRunReport = isValid
      if (isValid) {
        if (self.scheduler.newEmail.length > 0) {
          notify('Please save the email or clear the box', 'warning', 5500)
          return
        }
        this.updateComparedLenders()

        this.activeReport.UseReportDefaultColumns = self.UseReportDefaultColumns;
        //this.activeReport.SelectedReport.ReportName = self.ReportSelectedColumns;
       
        this.activeReport.ReportSelectedColumns = self.ReportSelectedColumns;

        console.log("self.ReportSelectedColumns", self.ReportSelectedColumns)
        let obj = {
          activeReport: this.activeReport,
          scheduler: {
            'MGAUGE_SCHEDULER_ID': self.scheduler.MGAUGE_SCHEDULER_ID,
            'DEALERSHIP_ID': self.scheduler.DEALERSHIP_ID,
            'SCHEDULE': self.scheduler.SCHEDULE,
            'TEMPLATE_ID': self.activeReport.id, // TODO: REVIEW TEMPLATE_ID
            'SCHEDULE_EMAIL': self.scheduler.SCHEDULE_EMAIL.join(';'),
            'IS_ACTIVE': self.scheduler.IS_ACTIVE
          }
        }

        console.log("obj", obj);

        axios.post('/api/mgauge/savereporttemplate', obj)
          .then(response => {
            this.boolLoading = false
            this.activeReport = response.data
            this.loadtemplatecategories(this.SelectedCategory.CategoryId)
            this.changesSaved = true
            var msg = 'Report has been saved'
            if (parseErrors.length > 0) {
              msg = 'Template has been saved excluding date errors: ' + parseErrors.toString()
              this.errMsg = msg
              this.showDismissibleAlert = true
            } else { notify(msg, 'success', 3500) }

            if (hide) {
              this.$refs.AddEditTemplate.hide()
            }
          })
          .catch(error => {
            if (error.response.status === 403) {
              this.$router.push('/login')
            }
            if (error.response.status === 500) {
              console.log('time zone message', error.response.data.split(':')[1].indexOf('In order to'))
              if (error.response.data.split(':')[1].indexOf('In order to') > 0) {
                this.getCurrent()
                this.$refs.modalTimezoneWarning.show()
              }
            } else { this.errMsg = 'There was an error getting data : ' + error }

            this.boolLoading = false
            this.showDismissibleAlert = true
          })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    },
    modalTimeZoneWarningHandleOK () {
      this.IsModalTimeZoneWarningHandleOKPressed = true
      this.updateTimeZone()
    },
    modalTimeZoneWarningHandleHidden () {
      if (this.IsModalTimeZoneWarningHandleOKPressed) {
        this.saveReportTemplate()
        this.IsModalTimeZoneWarningHandleOKPressed = false
      }
    },
    getCurrent () {
      var self = this
      axios.get('/api/UserManagement/GetCurrent')
        .then(response => {
          self.boolLoading = false
          if (response.data === undefined || response.data === null) {
            self.user = {}
          } else {
            self.user = response.data
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }
          self.boolLoading = false
          self.errMsg = 'There was an error getting data : ' + error
          self.showDismissibleAlert = true
        })
    },
    updateTimeZone () {
      var self = this
      var obj = {
        'timezoneid': self.user.TIMEZONE_ID,
        'personid': self.user.PERSON_ID
      }

      axios.post('/api/profile/updatetimezone', obj)
        .then(response => {
          self.errMsg = 'Your time zone has been updated'
          self.dismissibleType = 'success'
          self.showDismissibleAlert = true
          self.boolLoading = false
          self.getCurrent()
          this.$refs.modalTimezoneWarning.hide()
        })
        .catch(error => {
          if (error.response.status === 403) {
            self.$router.push('/login')
          }

          console.log(error)
          self.boolLoading = false
          // self.errMsg = 'There was an error updating your timezone: ' + error
          alert('There was an error updating your timezone: ' + error, 'Error')
          self.showDismissibleAlert = true
        })
    },
    IsSchedulerValid () {
      let self = this
      var currenTime = new Date()
      var currentMonth = currenTime.getMonth() + 1
      var currentYear = currenTime.getFullYear()
      var days = self.GetDaysByMonth(currentMonth, currentYear)
      var errors = []
      for (var i = 0; i < self.scheduler.SCHEDULE.length; i++) {
        var item = self.scheduler.SCHEDULE[i]
        for (var j = 0; j < item.times.length; j++) {
          var timeItem = item.times[j]
          if (item.date > days) {
            errors.push(currentYear + '/' + (currentMonth) + '/' + item.date + ' ' + timeItem + ':00')
          }
        }
      }
      return errors
    },
    GetDaysByMonth (month, year) {
      return new Date(year, month, 0).getDate()
    },

    deleteReportTemplate () {
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mgauge/deletereporttemplate', this.activeReport)
            .then(response => {
              this.boolLoading = false
              notify('Report has been deleted', 'success', 3500)
              this.loadtemplatecategories(-1)
              this.initLoad = true
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        }
      })
    },
    trueValidateAllSilent (resetNeeded) {
      let self = this
      if (resetNeeded === undefined || resetNeeded === null) {
        resetNeeded = true
      }
      let validations = []
      validations.push(self.$validator.validate('Title.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step1.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step2.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step3.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step4.*', undefined, {silent: true}))
      validations.push(self.$validator.validate('Step5.*', undefined, {silent: true}))

      return Promise.all(validations).then(results => {
        const retValue = results.every(r => r)

        if (resetNeeded === true) {
          self.$validator.reset('Title.*')
          self.$validator.reset('Step1.*')
          self.$validator.reset('Step2.*')
          self.$validator.reset('Step3.*')
          self.$validator.reset('Step4.*')
          self.$validator.reset('Step5.*')
        }
        return retValue
      })
    },
    trueValidateAll () {
      let self = this
      let validations = []
      validations.push(self.$validator.validateAll('Title'))
      validations.push(self.$validator.validateAll('Step1'))
      validations.push(self.$validator.validateAll('Step2'))
      validations.push(self.$validator.validateAll('Step3'))
      validations.push(self.$validator.validateAll('Step4'))
      validations.push(self.$validator.validateAll('Step5'))
      if (self.scheduler.SCHEDULE.length > 0 && self.scheduler.IS_ACTIVE) {
        validations.push(self.$validator.validateAll('Step7'))
      }
      return Promise.all(validations).then(results => results.every(r => r))
    },
    async runReport () {
      let self = this
      const isValid = await self.trueValidateAll()
      if (isValid) {
        self.boolLoading = true
        self.updateComparedLenders()
        axios.post('/api/mgauge/runreport', this.activeReport)
          .then(response => {
            self.boolLoading = false
            // this.errMsg = 'Report queued successfuly. ID:' + response.data.processId + ' Running:' + new Date().toString()
            // this.dismissibleType = 'success'
            // this.showDismissibleAlert = true
            self.saveReportTemplate(false)
            setTimeout(function () {
              notify('Your report has been queued', 'success', 3500)
              // self.$router.push('/mGauge/ReportHistory')
            }, 1500)
          })
          .catch(error => {
            if (error.response.status === 403) {
              this.$router.push('/login')
            }

            if (error.response.status === 400) {
              this.boolLoading = false
              this.errMsg = 'Incorrect zip code '
              this.showDismissibleAlert = true

              notify('Incorrect zip code', 'error', 3500)
            } else {
              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true

              notify('Error running report', 'error', 3500)
            }
          })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    },

    async runAllSelectedReports () {
      let self = this
      const isValid = await self.trueValidateAll()
      if (isValid) {
        // self.updateComparedLenders()
        //console.log('this.filteredReports', this.filteredReports)
        var selectedReports = this.filteredReports.filter(x => this.IsSelected(x))
        if (selectedReports != null && selectedReports.length === 0) {
          // alert("There is no report selected!");
          notify('There is no report selected!', 'error', 3500)
          return
        }

        let result = confirm('You will process ' + selectedReports.length + ' reports. Are you sure? Y/N', 'Confirm')
        result.then((dialogResult) => {
          if (dialogResult) {
            self.boolLoading = true
            var object = {
              'SelectedReports': selectedReports
            }
            axios.post('/api/mgauge/runselectedreports', object)
              .then(response => {
                self.boolLoading = false
                var processedReports = response.data.result
                var htmlMessage = `
    <table class='table table-bordered table-striped table-hover'>
      <tr>
          <td>TemplateId</td>
          <td>Title</td>
          <td>IsProcessed</td>
          <td>Error</td>
      </tr>
`
                var rowsMessages = ``
                for (var i = 0; i < processedReports.length; i++) {
                  var rowsMessage = `
                        <tr>
                            <td>` + processedReports[i].TemplateId + `</td>
                            <td>` + processedReports[i].Title + `</td>
                            <td>` + processedReports[i].IsProcessed + `</td>
                            <td>` + processedReports[i].Error + `</td>
                        </tr>
`
                  rowsMessages += rowsMessage
                }
                htmlMessage += rowsMessages
                htmlMessage += `</table>`

                alert(htmlMessage, 'Information')

                setTimeout(function () {
                  notify('Your report(s) has been queued', 'success', 3500)

                  // Unselect
                  for (var i = 0; i < selectedReports.length; i++) {
                    selectedReports[i].IsSelected = false
                  }
                }, 1500)
              })
              .catch(error => {
                if (error.response.status === 403) {
                  this.$router.push('/login')
                }

                if (error.response.status === 400) {
                  this.boolLoading = false
                  this.errMsg = 'Incorrect zip code '
                  this.showDismissibleAlert = true

                  notify('Incorrect zip code', 'error', 3500)
                } else {
                  this.boolLoading = false
                  this.errMsg = 'There was an error getting data : ' + error
                  this.showDismissibleAlert = true

                  notify('Error running report', 'error', 3500)
                }
              })
          } else {
            notify('The action was cancelled', 'error', 3500)
          }
        })
      } else {
        notify('Please fix validation errors first', 'warning', 5500)
      }
    },

    clickApplicableCaptiveLender (event) {
      this.availableLenders.forEach(function (i) {
        i.Tracked = false
      })
      this.activeReport.trackedLender = null
      this.activeReport.applicableCaptiveLender = event
      this.activeReport.useTargetAcquisition = false
      this.changesSaved = false
    },
    selectAllComparedLenders () {
      if (this.activeReport.comparedLenders.length) {
        this.availableLenders.forEach(function (i) {
          i.Compared = false
        })
      } else {
        this.availableLenders.forEach(function (i) {
          i.Compared = true
        })
      }
      this.updateComparedLenders()
      this.changesSaved = false
    },
    updateComparedLenders () {
      this.activeReport.comparedLenders = this.selectedComparedLenders
    },

    wizardBackStep () {
      let self = this
      self.wizardStep = self.wizardStep - 1
      // self.wizardBackStepClicked = true
    },

    async wizardTabClick (newTabIndex, prevTabIndex, evt) {
      let self = this

      // if (self.wizardBackStepClicked === true) {
      //  self.wizardBackStepClicked = false
      //  return false
      // }

      if (self.wizardStepToChange !== newTabIndex) {
        evt.preventDefault()
      }
      let validateTab = parseInt(parseInt(prevTabIndex) + 1)
      let validationTarget = 'Step' + validateTab

      self.canRunReport = await self.trueValidateAllSilent(false)

      let isValid = await self.$validator.validateAll(validationTarget)
      if (isValid) {
        // self.changesSaved = false
        self.wizardStepToChange = newTabIndex
        self.wizardStep = newTabIndex
      }
      return false
    },
    async wizardNextStep (tabID, validationTarget) {
      // console.log(`tabID ${tabID} validationTarget ${validationTarget}`)
      let self = this
      // console.log(`0 tabID ${tabID} validationTarget ${validationTarget} self.canRunReport ${self.canRunReport}`)
      self.canRunReport = await self.trueValidateAllSilent(false)

      // console.log(`1 tabID ${tabID} validationTarget ${validationTarget} self.canRunReport ${self.canRunReport}`)

      let promise = new Promise(async (resolve, reject) => {
        // console.log(`2 tabID ${tabID} validationTarget ${validationTarget}`)

        const isValid = await self.$validator.validateAll(validationTarget)
        // console.log(`isValid: ${JSON.stringify(isValid)}`)
        if (isValid === true) {
          resolve(isValid)
        } else {
          reject(isValid)
        }
      })

      promise.then(value => {
        // console.log(`5 tabID ${tabID} validationTarget ${validationTarget}`)
        // self.changesSaved = false
        self.wizardStep = parseInt(tabID + '')
      }, reason => {
        // console.log(`6 tabID ${tabID} validationTarget ${validationTarget}`)
      })

      // console.log(`4 tabID ${tabID} validationTarget ${validationTarget}`)

      return undefined
    },
    UseReportDefaultColumnsChange(event) {
      let self = this;
      //console.log("event", event)
      if (event === true) {
        let result = confirm('All selected report fields will be cleared.', 'Warning')
        result.then((dialogResult) => {
          if (dialogResult) {
            self.ReportSelectedColumns = []
            self.setComlumnReportsAssign()
          } else {
            self.UseReportDefaultColumns = false;
          }
        })
       
      }      
    },
    ChangeUseAverageReport(event) {
      let self = this;
      self.activeReport.useAverageReport = event
      //console.log("event", event)
      let result = confirm('All selected report fields will be cleared.', 'Warning')
      result.then((dialogResult) => {
        if (dialogResult) {
          self.UseReportDefaultColumns = true;
          self.ReportSelectedColumns = []
          self.setComlumnReportsAssign()
        }
      })

    },
    setSelectedGroupBy(groupBy) {
      let self = this;
      //console.log("groupBy", groupBy)
      let result = confirm('All selected report fields will be cleared.', 'Warning')
      result.then((dialogResult) => {
        if (dialogResult) {
          self.UseReportDefaultColumns = true;
          self.ReportSelectedColumns = []
          self.setComlumnReportsAssign()
        } 
      })
    },
    GetError (param) {
      let self = this
      let err = self.validateErrors.first(param)
      if (err !== undefined) {
        return {message: err}
      }
      return undefined
    },
    HasError (param) {
      let self = this
      if (self.validateErrors.first(param) !== undefined) {
        return false
      }
      return true
    },
    HandleTestValues (e) {
      let self = this
      // console.log(`ctrl: ${e.ctrlKey} shift: ${e.shiftKey} alt: ${e.altKey} key: ${e.key} keyCode: ${e.keyCode}`)
      if (e !== undefined && e !== null) {
        if (e.ctrlKey === true && e.shiftKey === true && e.altKey === true && e.key === 'T') {
          if (self.wizardStep === 0) {
            // zipCode
            self.activeReport.zipCode = '93012'
            // vehicleSet
            if (self.vehicleSets.length > 0) {
              self.activeReport.vehicleSet = self.vehicleSets[0].id
            }
            self.activeReport.creditScore = '720'
            self.activeReport.cashType = 0
            self.activeReport.cashDown = '2000'
            self.showCustomMileage = false
            self.activeReport.annualMileage = '10000'
            self.activeReport.scanMode = 0
            self.activeReport.scanType = 0
            self.activeReport.adjustmentType = 0
            self.activeReport.adjustmentValueType = 0
            self.activeReport.adjustmentValue = '5000'
          }
          if (self.wizardStep === 3) {
            self.activeReport.targetAcquisition.targetPayment = 100
            self.activeReport.targetAcquisition.raiseResidualPctAdj = 20
            self.activeReport.targetAcquisition.lowerResidualPctAdj = 1

            self.activeReport.targetAcquisition.raiseMoneyFactor = '0.001'
            self.activeReport.targetAcquisition.lowerMoneyFactor = '0.00001'
            self.activeReport.targetAcquisition.raiseInterestRate = '99'
            self.activeReport.targetAcquisition.lowerInterestRate = '98'
          }
        }
      }
    },
    onDragStart(e) {
      e.itemData = this[e.fromData][e.fromIndex];
    },
    onAdd(e) {
      const data = [...this[e.toData]];
      data.splice(e.toIndex, 0, e.itemData);
      this[e.toData] = data;
    },
    onRemove(e) {
      const data = [...this[e.fromData]];
      data.splice(e.fromIndex, 1);
      this[e.fromData] = data;
    }
  },
  computed: {
    VehicleSetIsNew () {
      let self = this
      if (self.activeReport.vehicleSet === undefined || self.activeReport.vehicleSet === null) { return true }
      let vehicleSet = self.vehicleSets.find(vs => vs.id === self.activeReport.vehicleSet)
      if (vehicleSet === undefined || vehicleSet === null) { return true }
      return vehicleSet.isnew
    },
    SchedulerCanAddEmail () {
      let self = this
      let emailRegex = /\S+@\S+\.\S+/
      if (self.scheduler !== undefined && self.scheduler.newEmail !== undefined && self.scheduler.newEmail !== null && self.scheduler.newEmail.length > 0 && emailRegex.test(self.scheduler.newEmail)) {
        return true
      }
      return false
    },
    SchedulerCanAdd () {
      let self = this
      if (self.scheduler !== undefined && self.scheduler.newTime !== undefined && self.scheduler.newDate !== undefined && self.scheduler.newTime !== null && self.scheduler.newDate !== null) {
        return true
      }
      return false
    },
    lenderCalcType () {
      if (this.activeReport.applicableCaptiveLender === true) {
        return this.activeReport.scanMode === 0 ? 2 : 3
      }
      if (this.activeReport.scanMode === 1) {
        return 3
      }

      let rtnValue = 0
      let hasMF = false
      let hasIR = false

      // let i = this.activeReport.trackedLender

      if (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null) {
        if (this.activeReport.trackedLender.hasMoneyFactor) {
          hasMF = true
        }
        if (this.activeReport.trackedLender.hasInterestRate) {
          hasIR = true
        }
      }

      if (hasIR) {
        rtnValue = 3
      }
      if (hasMF) {
        rtnValue = 2
      }
      if (hasMF && hasIR) {
        rtnValue = 1
      }
      if (!hasMF && !hasIR) {
        rtnValue = 2
      }
      if (this.activeReport.trackedLender !== undefined &&
        this.activeReport.trackedLender !== null &&
        this.activeReport.trackedLender.Name === 'Ford Motor Credit') {
        rtnValue = 4
      }

      return rtnValue
    },
    selectedTrackedLender () {
      return this.availableLenders.filter(f => {
        return f.Tracked
      })
    },
    selectedComparedLenders () {
      return this.availableLenders.filter(f => {
        return f.Compared && (this.activeReport.trackedLender !== undefined && this.activeReport.trackedLender !== null ? f.Name !== this.activeReport.trackedLender.Name : true)
      })
    },
    filteredLenders () {
      return this.availableLenders.filter(item => {
        return item.Name.toLowerCase().indexOf(this.lenderSearch.toLowerCase()) > -1
      })
    }
  },
  watch: {
    'scheduler.use24format': function (val, oldVal) {
      // console.log(`use24format val: ${val} oldVal: ${oldVal}`)
      let self = this
      self.SchedulerSort()
    },
    activeReport:
    {
      handler (newVal, oldVal) {
        this.changesSaved = false
      },
      deep: true
    },
    'scheduler.IS_ACTIVE':
    {
      handler (newVal, oldVal) {
        this.changesSaved = false
      },
      deep: true
    },
    showCustomMileage: function (val, oldVal) {
      let self = this
      let annValue = 0
      if (val !== true && val !== 'true') {
        annValue = parseInt(self.activeReport.annualMileage)
        // console.log(`val: ${val} oldVal: ${oldVal} annValue: ${annValue}`)
        switch (annValue) {
          case 2500:
            return
          case 7500:
            return
          case 10000:
            return
          case 12000:
            return
          case 15000:
            return
          default:
            if (annValue >= 15000) {
              self.activeReport.annualMileage = '15000'
            } else if (annValue >= 12000) {
              self.activeReport.annualMileage = '12000'
            } else if (annValue >= 10000) {
              self.activeReport.annualMileage = '10000'
            } else if (annValue >= 7500) {
              self.activeReport.annualMileage = '7500'
            } else {
              self.activeReport.annualMileage = '2500'
            }
        }
      }
    }
  },
  filters: {
    formatDate: function (str) {
      if (!str) { return '' }
      str = new Date(str)
      return moment(String(str)).format('MM/DD/YY hh:mm A')
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('keydown', self.HandleTestValues)
  },
  beforeRouteLeave (to, from, next) {
    // console.log(`${from} -> ${to}`)
    if (!this.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    } else {
      return next()
    }
  },

  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style scoped>
  .disabledTab {
    pointer-events: none;
  }

  .dx-overlay-content {
    min-width: initial !important;
  }

  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .dx-widget .dx-slider-handle {
    background-color: #34b9a7;
  }

  .dx-slider-bar {
    background: #4bc300;
  }

  .centerDiv {
    margin-left: auto;
    margin-right: auto;
  }

  .vcenter {
    margin-top: auto;
    margin-bottom: auto;
  }

  .disableTA {
    pointer-events: none;
    opacity: 0.2;
  }

  .disableRebates {
    pointer-events: none;
    opacity: 0.2;
  }

  .numbercenter {
     text-align: center;
}
  .template_rows {
    display: flex;
    flex: 10;
    flex-flow: column;
    border: 1px solid lightgray;
    max-height: 700px;
    min-height: 300px;
    overflow-y: auto;
  }

  .report_row {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    transition: 0.3s;
  }
  .report_row_slim_header {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    background-color:lightgray;
    height: 35px;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    padding-top: 2px;
    transition: 0.3s;
  }
  .report_row_slim {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 35px;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    padding-top: 2px;
    transition: 0.3s;
  }

  .report_row_hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #f0f3f5;
    /*font-weight: bold;*/
  }

  .report_row:hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #eae1e1;
    /*font-weight: bold;*/
  }

  .report-column {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 35px;
    padding-bottom: 1px;
    padding-top: 1px;
    /*background-color: #fFfFfF;*/
    align-items: center;
    padding-left: 3px;
  }
    .report-column:hover {
      display: flex;
      flex-flow: row;
      border-bottom: 1px solid lightgray;
      height: 35px;
      padding-bottom: 1px;
      padding-top: 1px;
      padding-left: 3px;
      background-color: #eae1e1;
      align-items: center;
    }

  .report_column_hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 35px;
    /*justify-content: center;*/
    align-items: center;
    padding-bottom: 1px;
    padding-top: 1px;
    background-color: #ffffff;
    /*font-weight: bold;*/
  }

  .category {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 40px;
    justify-content: center;
    align-items: center;
    font-weight: 100;
    transition: 0.3s;
  }

    .category:hover {
      background-color: #ddd;
      opacity: 0.6;
    }

  .category_selected {
    background-color: #ddd;
    font-weight: bold;
  }

  .headerCategory {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    /*height: 40px;*/
    justify-content: center;
    align-items: center;
    background-color: #f0f3f5;
  }

  .customCategory {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 40px;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
  }

    .customCategory:hover {
      background-color: #ddd;
      opacity: 0.6;
    }

  .categories {
    display: flex;
    flex: 2;
    flex-flow: column;
    width: 250px;
    max-height:700px;
  }

  .category_action {
    display: flex;
    flex: 2;
    margin-right: 10px;
  }

  .category_title {
    display: flex;
    flex: 10;
    margin-left: 10px;
  }

  .report_id {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 10px;
  }

  .report_template_name {
    display: flex;
    flex-flow: column;
    flex: 5;
    padding-left: 3px;
  }

  .report_user {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_category {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_is_active {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_date {
    display: flex;
    flex-flow: column;
    flex: 2;
    padding-left: 3px;
  }

  .report_time {
    display: flex;
    flex-flow: column;
    flex: 1;
  }

  .report_xls {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_html {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_json {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }

  .report_action {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .dx-scrollview-content {
    min-height: 380px;
  }
  .grab {
    cursor: -webkit-grab;
    cursor: grab;
  }
</style>



// WEBPACK FOOTER //
// src/views/mGaugeRunReport.vue